(function(){var _run=function(){

var _allSteps = document.querySelectorAll('.mb-step');
_allSteps.forEach(function(s){s.style.display='none';});
var _step1 = document.querySelector('[data-step="1"]');
if(_step1){_step1.style.display='block';}
var HELIPORTS=[
 {id:'NCE',name:'Nice',label:'Nice — NCE'},
 {id:'MCM',name:'Monaco',label:'Monaco — MCM'},
 {id:'CEQ',name:'Cannes — Mandelieu',label:'Cannes Mandelieu — CEQ'},
 {id:'CNQ',name:'Cannes — Quai du Large',label:'Cannes Quai du Large — CNQ'},
 {id:'LTT',name:'Saint-Tropez — La Môle',label:'Saint-Tropez La Môle — LTT'},
 {id:'STG',name:'Saint-Tropez — Grimaud',label:'Saint-Tropez Grimaud — STG'},
 {id:'TLN',name:'Toulon',label:'Toulon — TLN'},
 {id:'MRS',name:'Marseille',label:'Marseille — MRS'},
 {id:'CTT',name:'Le Castellet',label:'Le Castellet — CTT'},
 {id:'CLY',name:'Calvi',label:'Calvi — CLY'},
 {id:'OLB',name:'Porto-Cervo',label:'Porto-Cervo — OLB'},
 {id:'GOA',name:'Portofino',label:'Portofino — GOA'},
 {id:'FDM',name:'Forte dei Marmi',label:'Forte dei Marmi — FDM'},
 {id:'TRN',name:'Turin',label:'Turin — TRN'},
 {id:'MXP',name:'Milan — Malpensa',label:'Milan Malpensa — MXP'},
 {id:'MIL',name:'Milan — Bresso',label:'Milan Bresso — MIL'},
 {id:'CMO',name:'Como',label:'Como — CMO'},
 {id:'MVG',name:'Megève',label:'Megève — MVG'},
 {id:'CVF',name:'Courchevel',label:'Courchevel — CVF'},
 {id:'MEB',name:'Méribel',label:'Méribel — MEB'},
 {id:'VAT',name:"Val d'Isère",label:"Val d'Isère — VAT"},
 {id:'GNB',name:'Grenoble',label:'Grenoble — GNB'},
 {id:'CMF',name:'Chambéry',label:'Chambéry — CMF'},
 {id:'NCY',name:'Annecy',label:'Annecy — NCY'},
 {id:'LYN',name:'Lyon — Bron',label:'Lyon Bron — LYN'},
 {id:'LYS',name:'Lyon — Saint-Exupéry',label:'Lyon Saint-Exupéry — LYS'},
 {id:'GVA',name:'Genève',label:'Genève — GVA'},
 {id:'SIR',name:'Sion',label:'Sion — SIR'},
 {id:'GSA',name:'Gstaad',label:'Gstaad Saanen — GSA'},
 {id:'ZMT',name:'Zermatt',label:'Zermatt — ZMT'}
];
var HELI_SUGGESTIONS={
 'NCE': ['MCM','CEQ','CNQ','LTT','STG'],
 'MCM': ['NCE','CEQ','LTT','CVF','GVA'],
 'CEQ': ['NCE','MCM','LTT','STG'],
 'CNQ': ['NCE','MCM','LTT','STG'],
 'LTT': ['NCE','MCM','CEQ','CNQ'],
 'STG': ['NCE','MCM','CEQ','CNQ'],
 'CVF': ['GVA','NCE','MCM','MXP','CMO'],
 'GVA': ['CVF','MEB','VAT','GSA','ZMT'],
 'MXP': ['CMO','CVF','GVA','NCE'],
 'CMO': ['MXP','CVF','GVA'],
 'GNB': ['CVF','MEB','NCY'],
 'NCY': ['CVF','MEB','GNB','GVA']
};
var HELICOPTERS=[
 {id:'h125',name:'Airbus H125',sub:'Single-engine',pax:5,speed:230,luggage:'3·2 bags',desc:'Flagship light utility.',images:window.LL_IMGS&&window.LL_IMGS['h125']||[]},
 {id:'h130',name:'Airbus H130',sub:'Single-engine',pax:6,speed:230,luggage:'3·3 bags',desc:'Panoramic windows, wider cabin.',images:window.LL_IMGS&&window.LL_IMGS['h130']||[]},
 {id:'as355',name:'Airbus AS355',sub:'Twin-engine',pax:5,speed:220,luggage:'3·2 bags',desc:'Twin-engine reliability.',images:window.LL_IMGS&&window.LL_IMGS['as355']||[]},
 {id:'h135',name:'Airbus H135',sub:'Twin-engine',pax:5,speed:220,luggage:'3·2 bags',desc:'Fast, silent and agile.',images:window.LL_IMGS&&window.LL_IMGS['h135']||[]},
 {id:'bell429',name:'Bell 429',sub:'Twin-engine',pax:6,speed:250,luggage:'4·4 bags',desc:'Spacious cabin, 722 km range.',images:window.LL_IMGS&&window.LL_IMGS['bell429']||[]},
 {id:'h155',name:'Airbus H155',sub:'Twin-engine · VIP',pax:6,speed:280,luggage:'5·5 bags',desc:'Ultra-quiet, 280 km/h.',badge:'Premium',images:window.LL_IMGS&&window.LL_IMGS['h155']||[]}
];

var VEHICLES=[
 {id:'e-class',name:'Mercedes E-Class',sub:'Executive Sedan',pax:3,luggage:'3 bags',feat:'Leather · A/C · WiFi',images:window.LL_IMGS&&window.LL_IMGS['e-class']||[]},
 {id:'v-class',name:'Mercedes V-Class',sub:'Premium Van',pax:7,luggage:'7 bags',feat:'Captain seats · Privacy',badge:'Most popular',images:window.LL_IMGS&&window.LL_IMGS['v-class']||[]},
 {id:'s-class',name:'Mercedes S-Class',sub:'Luxury Limousine',pax:3,luggage:'3 bags',feat:'Massage · Ambient · Bar',images:window.LL_IMGS&&window.LL_IMGS['s-class']||[]},
 {id:'range-rover',name:'Range Rover Vogue',sub:'Luxury SUV',pax:4,luggage:'4 bags',feat:'Air suspension · Off-road',images:window.LL_IMGS&&window.LL_IMGS['range-rover']||[]}
];
var AIRPORTS=[
 {code:'NCE',name:"Nice Côte d'Azur"},{code:'MRS',name:'Marseille Provence'},{code:'TLN',name:'Toulon-Hyères'},
 {code:'CDG',name:'Paris Charles de Gaulle'},{code:'ORY',name:'Paris Orly'},{code:'LBG',name:'Paris Le Bourget'},
 {code:'LYS',name:'Lyon Saint-Exupéry'},{code:'TLS',name:'Toulouse Blagnac'},{code:'BOD',name:'Bordeaux Mérignac'},
 {code:'NTE',name:'Nantes Atlantique'},{code:'SXB',name:'Strasbourg'},{code:'CAN',name:'Cannes Mandelieu'},
 {code:'BSL',name:'Bâle-Mulhouse'},{code:'GVA',name:'Genève'},{code:'ZRH',name:'Zurich'},
 {code:'MXP',name:'Milan Malpensa'},{code:'LIN',name:'Milan Linate'},{code:'TRN',name:'Turin'},
 {code:'FCO',name:'Rome Fiumicino'},{code:'VCE',name:'Venise Marco Polo'},{code:'BCN',name:'Barcelone El Prat'}
];
var TRAINS=[
 {code:'PARIS-GL',name:'Paris Gare de Lyon'},{code:'PARIS-MN',name:'Paris Montparnasse'},{code:'PARIS-PN',name:'Paris Gare du Nord'},
 {code:'PARIS-SE',name:'Paris Saint-Lazare'},{code:'PARIS-ES',name:'Paris Est'},
 {code:'NICE',name:'Nice Ville'},{code:'CANNES',name:'Cannes'},{code:'ANTIBES',name:'Antibes'},
 {code:'MONACO',name:'Monaco Monte-Carlo'},{code:'MENTON',name:'Menton'},{code:'MRS',name:'Marseille Saint-Charles'},
 {code:'LYON-PD',name:'Lyon Part-Dieu'},{code:'LYON-PS',name:'Lyon Perrache'},
 {code:'BORDEAUX',name:'Bordeaux Saint-Jean'},{code:'TOULOUSE',name:'Toulouse Matabiau'},
 {code:'NANTES',name:'Nantes'},{code:'STRASBOURG',name:'Strasbourg'},
 {code:'GRENOBLE',name:'Grenoble'},{code:'ANNECY',name:'Annecy'},{code:'CHAMBERY',name:'Chambéry'},
 {code:'MILAN-C',name:'Milan Centrale'},{code:'GENEVE',name:'Genève Cornavin'},{code:'LAUSANNE',name:'Lausanne'}
];
var ALL_COUNTRIES=[{f:'🇦🇫',n:'Afghanistan',c:'+93',p:'70 000 0000'},{f:'🇦🇱',n:'Albania',c:'+355',p:'06 000 0000'},{f:'🇩🇿',n:'Algeria',c:'+213',p:'0550 00 00 00'},{f:'🇦🇩',n:'Andorra',c:'+376',p:'312 345'},{f:'🇦🇴',n:'Angola',c:'+244',p:'923 000 000'},{f:'🇦🇬',n:'Antigua & Barbuda',c:'+1',p:'268 000 0000'},{f:'🇦🇷',n:'Argentina',c:'+54',p:'011 1234-5678'},{f:'🇦🇲',n:'Armenia',c:'+374',p:'077 000 000'},{f:'🇦🇺',n:'Australia',c:'+61',p:'0400 000 000'},{f:'🇦🇹',n:'Austria',c:'+43',p:'0664 000000'},{f:'🇦🇿',n:'Azerbaijan',c:'+994',p:'050 000 00 00'},{f:'🇧🇸',n:'Bahamas',c:'+1',p:'242 000 0000'},{f:'🇧🇭',n:'Bahrain',c:'+973',p:'3600 0000'},{f:'🇧🇩',n:'Bangladesh',c:'+880',p:'01700 000000'},{f:'🇧🇧',n:'Barbados',c:'+1',p:'246 000 0000'},{f:'🇧🇾',n:'Belarus',c:'+375',p:'029 000 00 00'},{f:'🇧🇪',n:'Belgium',c:'+32',p:'0470 12 34 56'},{f:'🇧🇿',n:'Belize',c:'+501',p:'600 0000'},{f:'🇧🇯',n:'Benin',c:'+229',p:'90 00 00 00'},{f:'🇧🇹',n:'Bhutan',c:'+975',p:'17 000 000'},{f:'🇧🇴',n:'Bolivia',c:'+591',p:'7000 0000'},{f:'🇧🇦',n:'Bosnia & Herzegovina',c:'+387',p:'061 000 000'},{f:'🇧🇼',n:'Botswana',c:'+267',p:'71 000 000'},{f:'🇧🇷',n:'Brazil',c:'+55',p:'11 91234-5678'},{f:'🇧🇳',n:'Brunei',c:'+673',p:'714 0000'},{f:'🇧🇬',n:'Bulgaria',c:'+359',p:'087 000 0000'},{f:'🇧🇫',n:'Burkina Faso',c:'+226',p:'70 00 00 00'},{f:'🇧🇮',n:'Burundi',c:'+257',p:'79 000 000'},{f:'🇰🇭',n:'Cambodia',c:'+855',p:'012 000 000'},{f:'🇨🇲',n:'Cameroon',c:'+237',p:'6 70 00 00 00'},{f:'🇨🇦',n:'Canada',c:'+1',p:'204 000 0000'},{f:'🇨🇻',n:'Cape Verde',c:'+238',p:'991 0000'},{f:'🇨🇫',n:'Central African Republic',c:'+236',p:'72 00 00 00'},{f:'🇹🇩',n:'Chad',c:'+235',p:'63 00 00 00'},{f:'🇨🇱',n:'Chile',c:'+56',p:'9 1234 5678'},{f:'🇨🇳',n:'China',c:'+86',p:'131 0000 0000'},{f:'🇨🇴',n:'Colombia',c:'+57',p:'300 000 0000'},{f:'🇰🇲',n:'Comoros',c:'+269',p:'321 0000'},{f:'🇨🇬',n:'Congo',c:'+242',p:'06 000 0000'},{f:'🇨🇩',n:'Congo (DRC)',c:'+243',p:'099 000 0000'},{f:'🇨🇷',n:'Costa Rica',c:'+506',p:'8000 0000'},{f:'🇭🇷',n:'Croatia',c:'+385',p:'091 000 0000'},{f:'🇨🇺',n:'Cuba',c:'+53',p:'5 000 0000'},{f:'🇨🇾',n:'Cyprus',c:'+357',p:'96 000000'},{f:'🇨🇿',n:'Czech Republic',c:'+420',p:'601 000 000'},{f:'🇩🇰',n:'Denmark',c:'+45',p:'20 00 00 00'},{f:'🇩🇯',n:'Djibouti',c:'+253',p:'77 000 000'},{f:'🇩🇴',n:'Dominican Republic',c:'+1',p:'809 000 0000'},{f:'🇪🇨',n:'Ecuador',c:'+593',p:'99 000 0000'},{f:'🇪🇬',n:'Egypt',c:'+20',p:'0100 000 0000'},{f:'🇸🇻',n:'El Salvador',c:'+503',p:'7000 0000'},{f:'🇬🇶',n:'Equatorial Guinea',c:'+240',p:'222 000 000'},{f:'🇪🇷',n:'Eritrea',c:'+291',p:'7 000 000'},{f:'🇪🇪',n:'Estonia',c:'+372',p:'5000 0000'},{f:'🇸🇿',n:'Eswatini',c:'+268',p:'7600 0000'},{f:'🇪🇹',n:'Ethiopia',c:'+251',p:'091 000 0000'},{f:'🇫🇯',n:'Fiji',c:'+679',p:'700 0000'},{f:'🇫🇮',n:'Finland',c:'+358',p:'040 000 0000'},{f:'🇫🇷',n:'France',c:'+33',p:'6 12 34 56 78'},{f:'🇬🇦',n:'Gabon',c:'+241',p:'06 00 00 00'},{f:'🇬🇲',n:'Gambia',c:'+220',p:'700 0000'},{f:'🇬🇪',n:'Georgia',c:'+995',p:'555 00 00 00'},{f:'🇩🇪',n:'Germany',c:'+49',p:'0151 00000000'},{f:'🇬🇭',n:'Ghana',c:'+233',p:'024 000 0000'},{f:'🇬🇷',n:'Greece',c:'+30',p:'690 000 0000'},{f:'🇬🇹',n:'Guatemala',c:'+502',p:'5000 0000'},{f:'🇬🇳',n:'Guinea',c:'+224',p:'62 000 000'},{f:'🇬🇼',n:'Guinea-Bissau',c:'+245',p:'955 000 000'},{f:'🇬🇾',n:'Guyana',c:'+592',p:'600 0000'},{f:'🇭🇹',n:'Haiti',c:'+509',p:'34 00 0000'},{f:'🇭🇳',n:'Honduras',c:'+504',p:'9000 0000'},{f:'🇭🇰',n:'Hong Kong',c:'+852',p:'5000 0000'},{f:'🇭🇺',n:'Hungary',c:'+36',p:'06 20 000 0000'},{f:'🇮🇸',n:'Iceland',c:'+354',p:'611 0000'},{f:'🇮🇳',n:'India',c:'+91',p:'98765 43210'},{f:'🇮🇩',n:'Indonesia',c:'+62',p:'0812-0000-0000'},{f:'🇮🇷',n:'Iran',c:'+98',p:'0912 000 0000'},{f:'🇮🇶',n:'Iraq',c:'+964',p:'0790 000 0000'},{f:'🇮🇪',n:'Ireland',c:'+353',p:'085 000 0000'},{f:'🇮🇱',n:'Israel',c:'+972',p:'050 000 0000'},{f:'🇮🇹',n:'Italy',c:'+39',p:'312 000 0000'},{f:'🇯🇲',n:'Jamaica',c:'+1',p:'876 000 0000'},{f:'🇯🇵',n:'Japan',c:'+81',p:'090-0000-0000'},{f:'🇯🇴',n:'Jordan',c:'+962',p:'07 9000 0000'},{f:'🇰🇿',n:'Kazakhstan',c:'+7',p:'701 000 0000'},{f:'🇰🇪',n:'Kenya',c:'+254',p:'0712 000000'},{f:'🇰🇮',n:'Kiribati',c:'+686',p:'92000000'},{f:'🇽🇰',n:'Kosovo',c:'+383',p:'44 000 000'},{f:'🇰🇼',n:'Kuwait',c:'+965',p:'500 00000'},{f:'🇰🇬',n:'Kyrgyzstan',c:'+996',p:'700 000 000'},{f:'🇱🇦',n:'Laos',c:'+856',p:'20 00 000 000'},{f:'🇱🇻',n:'Latvia',c:'+371',p:'20 000 000'},{f:'🇱🇧',n:'Lebanon',c:'+961',p:'03 000 000'},{f:'🇱🇸',n:'Lesotho',c:'+266',p:'5000 0000'},{f:'🇱🇷',n:'Liberia',c:'+231',p:'077 000 0000'},{f:'🇱🇾',n:'Libya',c:'+218',p:'091 000 0000'},{f:'🇱🇮',n:'Liechtenstein',c:'+423',p:'660 000 000'},{f:'🇱🇹',n:'Lithuania',c:'+370',p:'600 00 000'},{f:'🇱🇺',n:'Luxembourg',c:'+352',p:'621 123 456'},{f:'🇲🇴',n:'Macao',c:'+853',p:'6000 0000'},{f:'🇲🇬',n:'Madagascar',c:'+261',p:'32 000 0000'},{f:'🇲🇼',n:'Malawi',c:'+265',p:'099 000 0000'},{f:'🇲🇾',n:'Malaysia',c:'+60',p:'012-000 0000'},{f:'🇲🇻',n:'Maldives',c:'+960',p:'770 0000'},{f:'🇲🇱',n:'Mali',c:'+223',p:'70 00 00 00'},{f:'🇲🇹',n:'Malta',c:'+356',p:'9900 0000'},{f:'🇲🇷',n:'Mauritania',c:'+222',p:'22 000 000'},{f:'🇲🇺',n:'Mauritius',c:'+230',p:'5200 0000'},{f:'🇲🇽',n:'Mexico',c:'+52',p:'55 1234 5678'},{f:'🇲🇩',n:'Moldova',c:'+373',p:'069 000 000'},{f:'🇲🇨',n:'Monaco',c:'+377',p:'06 00 00 00 00'},{f:'🇲🇳',n:'Mongolia',c:'+976',p:'9900 0000'},{f:'🇲🇪',n:'Montenegro',c:'+382',p:'067 000 000'},{f:'🇲🇦',n:'Morocco',c:'+212',p:'0600 000 000'},{f:'🇲🇿',n:'Mozambique',c:'+258',p:'82 000 0000'},{f:'🇲🇲',n:'Myanmar',c:'+95',p:'09 000 000 000'},{f:'🇳🇦',n:'Namibia',c:'+264',p:'081 000 0000'},{f:'🇳🇵',n:'Nepal',c:'+977',p:'984 000 0000'},{f:'🇳🇱',n:'Netherlands',c:'+31',p:'06 12345678'},{f:'🇳🇿',n:'New Zealand',c:'+64',p:'021 000 0000'},{f:'🇳🇮',n:'Nicaragua',c:'+505',p:'8000 0000'},{f:'🇳🇪',n:'Niger',c:'+227',p:'90 00 00 00'},{f:'🇳🇬',n:'Nigeria',c:'+234',p:'0803 000 0000'},{f:'🇲🇰',n:'North Macedonia',c:'+389',p:'070 000 000'},{f:'🇳🇴',n:'Norway',c:'+47',p:'400 00 000'},{f:'🇴🇲',n:'Oman',c:'+968',p:'9000 0000'},{f:'🇵🇰',n:'Pakistan',c:'+92',p:'0300 000 0000'},{f:'🇵🇼',n:'Palau',c:'+680',p:'775 0000'},{f:'🇵🇦',n:'Panama',c:'+507',p:'6000 0000'},{f:'🇵🇬',n:'Papua New Guinea',c:'+675',p:'700 00000'},{f:'🇵🇾',n:'Paraguay',c:'+595',p:'961 000 000'},{f:'🇵🇪',n:'Peru',c:'+51',p:'912 000 000'},{f:'🇵🇭',n:'Philippines',c:'+63',p:'0917 000 0000'},{f:'🇵🇱',n:'Poland',c:'+48',p:'500 000 000'},{f:'🇵🇹',n:'Portugal',c:'+351',p:'912 000 000'},{f:'🇶🇦',n:'Qatar',c:'+974',p:'3300 0000'},{f:'🇷🇴',n:'Romania',c:'+40',p:'0712 000 000'},{f:'🇷🇺',n:'Russia',c:'+7',p:'900 000-00-00'},{f:'🇷🇼',n:'Rwanda',c:'+250',p:'078 000 0000'},{f:'🇼🇸',n:'Samoa',c:'+685',p:'720 0000'},{f:'🇸🇲',n:'San Marino',c:'+378',p:'66 000000'},{f:'🇸🇦',n:'Saudi Arabia',c:'+966',p:'050 000 0000'},{f:'🇸🇳',n:'Senegal',c:'+221',p:'77 000 00 00'},{f:'🇷🇸',n:'Serbia',c:'+381',p:'060 000 0000'},{f:'🇸🇱',n:'Sierra Leone',c:'+232',p:'030 000000'},{f:'🇸🇬',n:'Singapore',c:'+65',p:'8000 0000'},{f:'🇸🇰',n:'Slovakia',c:'+421',p:'0900 000 000'},{f:'🇸🇮',n:'Slovenia',c:'+386',p:'040 000 000'},{f:'🇸🇧',n:'Solomon Islands',c:'+677',p:'74 00000'},{f:'🇸🇴',n:'Somalia',c:'+252',p:'61 000 0000'},{f:'🇿🇦',n:'South Africa',c:'+27',p:'071 000 0000'},{f:'🇰🇷',n:'South Korea',c:'+82',p:'010-0000-0000'},{f:'🇸🇸',n:'South Sudan',c:'+211',p:'091 000 0000'},{f:'🇪🇸',n:'Spain',c:'+34',p:'612 000 000'},{f:'🇱🇰',n:'Sri Lanka',c:'+94',p:'071 000 0000'},{f:'🇸🇩',n:'Sudan',c:'+249',p:'091 000 0000'},{f:'🇸🇷',n:'Suriname',c:'+597',p:'741 0000'},{f:'🇸🇪',n:'Sweden',c:'+46',p:'070-000 00 00'},{f:'🇨🇭',n:'Switzerland',c:'+41',p:'078 123 45 67'},{f:'🇸🇾',n:'Syria',c:'+963',p:'0944 000 000'},{f:'🇸🇹',n:'São Tomé & Príncipe',c:'+239',p:'981 0000'},{f:'🇹🇼',n:'Taiwan',c:'+886',p:'0912 000 000'},{f:'🇹🇯',n:'Tajikistan',c:'+992',p:'900 000 000'},{f:'🇹🇿',n:'Tanzania',c:'+255',p:'0612 000 000'},{f:'🇹🇭',n:'Thailand',c:'+66',p:'081 000 0000'},{f:'🇹🇱',n:'Timor-Leste',c:'+670',p:'772 0000'},{f:'🇹🇬',n:'Togo',c:'+228',p:'90 00 00 00'},{f:'🇹🇴',n:'Tonga',c:'+676',p:'777 0000'},{f:'🇹🇹',n:'Trinidad & Tobago',c:'+1',p:'868 000 0000'},{f:'🇹🇳',n:'Tunisia',c:'+216',p:'20 000 000'},{f:'🇹🇷',n:'Turkey',c:'+90',p:'0500 000 00 00'},{f:'🇹🇲',n:'Turkmenistan',c:'+993',p:'65 000000'},{f:'🇺🇬',n:'Uganda',c:'+256',p:'070 000 0000'},{f:'🇺🇦',n:'Ukraine',c:'+380',p:'067 000 0000'},{f:'🇦🇪',n:'United Arab Emirates',c:'+971',p:'050 000 0000'},{f:'🇬🇧',n:'United Kingdom',c:'+44',p:'07400 123456'},{f:'🇺🇸',n:'United States',c:'+1',p:'201 555 0123'},{f:'🇺🇾',n:'Uruguay',c:'+598',p:'091 000 000'},{f:'🇺🇿',n:'Uzbekistan',c:'+998',p:'90 000 00 00'},{f:'🇻🇺',n:'Vanuatu',c:'+678',p:'555 0000'},{f:'🇻🇦',n:'Vatican City',c:'+39',p:'06 698 0000'},{f:'🇻🇪',n:'Venezuela',c:'+58',p:'0412 000 0000'},{f:'🇻🇳',n:'Vietnam',c:'+84',p:'090 000 00 00'},{f:'🇾🇪',n:'Yemen',c:'+967',p:'0712 000 000'},{f:'🇿🇲',n:'Zambia',c:'+260',p:'097 0000000'},{f:'🇿🇼',n:'Zimbabwe',c:'+263',p:'071 000 0000'}];
var BTH_KM={3:60,4:80,5:100,6:120,7:140,8:160,9:180,10:200,11:200,12:200,14:200,16:200,18:200,20:200,24:200};
var ST=window._LL_ST={
 step:'1', svcs:[], tab:null, sub:null,
 heliDep:'', heliDest:'', heliT1:'', heliT2:'',
 owTime:'', owRetTime:'', bthTime:'', tbTime:'',
 selHeli:null, selVeh:null,
 hasRetOW:false, hasRetH:false,
 stopCntOW:0, stopCntBTH:0,
 phone:{code:'+33',flag:'🇫🇷',ph:'6 12 34 56 78'},
 pricesData:null,
 pickupType:null
};
function gi(id){return document.getElementById(id);}
function val(id){var e=gi(id);return e?e.value.trim():'';}
function isEmail(s){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);}
function closeAll(){
 document.querySelectorAll('.mb-dd-list').forEach(function(el){
 el.classList.remove('is-on');
 if(el.id&&el.id.indexOf('list-h-')===0){
 el.classList.remove('is-on');
 } else {
 el.style.display='none';
 }
 });
 document.querySelectorAll('.mb-loc-dd.is-on,.mb-pax-panel.is-on,.mb-phone-dd.is-on').forEach(function(el){
 el.classList.remove('is-on');
 el.style.display='';
 });
 document.querySelectorAll('.mb-dd-trigger.is-on,.mb-pax-trigger.is-on,.mb-loc-btn.is-on').forEach(function(el){el.classList.remove('is-on');});
}
var PROG_MAP={'1':1,'2':2,'2b':2,'2c':2,'3':3,'4':4};
function setProgress(stepId){
 var n=PROG_MAP[stepId]||1;
 document.querySelectorAll('.mb-prog-item').forEach(function(item){
 var p=parseInt(item.getAttribute('data-p'));
 item.classList.toggle('is-active',p===n);
 item.classList.toggle('is-done',p<n);
 if(p===n||p<n)item.querySelector('.mb-prog-fill').style.transform='scaleX(1)';
 else item.querySelector('.mb-prog-fill').style.transform='scaleX(0)';
 });
}
function goTo(id){
 document.querySelectorAll('.mb-step').forEach(function(s){s.classList.remove('is-active');s.style.cssText='';});
 var t=document.querySelector('[data-step="'+id+'"]');
 if(t){t.classList.add('is-active');t.style.display='block';t.style.visibility='visible';t.style.opacity='1';ST.step=id;}
 setProgress(id);
 document.querySelector('.mb-shell').scrollIntoView({behavior:'smooth',block:'start'});
}
function showErr(msg){
 var step=document.querySelector('.mb-step.is-active');if(!step)return;
 step.querySelectorAll('.mb-err').forEach(function(e){e.remove();});
 var actions=step.querySelector('.mb-actions');
 var el=document.createElement('div');el.className='mb-err';
 el.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><span>'+msg+'</span>';
 if(actions)actions.parentNode.insertBefore(el,actions);
 else step.appendChild(el);
 setTimeout(function(){el.remove();},6000);
}
document.querySelectorAll('.mb-svc-card').forEach(function(card){
 card.addEventListener('click',function(){
 card.classList.toggle('is-on');
 var s=card.getAttribute('data-svc');
 var i=ST.svcs.indexOf(s);
 if(i>-1)ST.svcs.splice(i,1); else ST.svcs.push(s);
 });
});
var SVG_ICONS={chauffeur:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="6" r="3"/><path d="M9 20v-6l-2-3h10l-2 3v6"/></svg>',helicopter:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 14h14"/><path d="M12 14V8"/><path d="M8 8h8"/></svg>','car-rental':'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 15h20M4 15l2-5h12l2 5"/></svg>',table:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2a7 7 0 0 1 7 7c0 3-1.5 5.5-4 6.5V17H9v-1.5C6.5 14.5 5 12 5 9a7 7 0 0 1 7-7z"/></svg>'};
var SVC_LABELS={chauffeur:'Chauffeur',helicopter:'Helicopter','car-rental':'Car Rental',table:'Table'};
function buildTabs(){
 var tabsEl=gi('mb-tabs');if(!tabsEl)return;
 tabsEl.innerHTML='';
 document.querySelectorAll('.mb-tab-panel').forEach(function(p){p.classList.remove('is-on');});
 ST.svcs.forEach(function(svc,i){
 var btn=document.createElement('button');btn.className='mb-tab';btn.setAttribute('data-tab',svc);
 btn.innerHTML=(SVG_ICONS[svc]||'')+'<span>'+SVC_LABELS[svc]+'</span>';
 if(i===0){btn.classList.add('is-on');var p=document.querySelector('[data-panel="'+svc+'"]');if(p)p.classList.add('is-on');ST.tab=svc;}
 btn.addEventListener('click',function(){
 document.querySelectorAll('.mb-tab').forEach(function(t){t.classList.remove('is-on');});
 document.querySelectorAll('.mb-tab-panel').forEach(function(p){p.classList.remove('is-on');});
 btn.classList.add('is-on');ST.tab=svc;
 var panel=document.querySelector('[data-panel="'+svc+'"]');if(panel)panel.classList.add('is-on');
 if(svc==='table')tbInit();
 });
 tabsEl.appendChild(btn);
 });
}
document.querySelectorAll('.mb-sub-card').forEach(function(card){
 card.addEventListener('click',function(){
 var wasOn=card.classList.contains('is-on');
 document.querySelectorAll('.mb-sub-card').forEach(function(c){c.classList.remove('is-on');});
 var ow=gi('panel-ow'),bth=gi('panel-bth');
 if(wasOn){ST.sub=null;if(ow)ow.classList.remove('is-on');if(bth)bth.classList.remove('is-on');}
 else{
 card.classList.add('is-on');ST.sub=card.getAttribute('data-sub');
 if(ST.sub==='one-way'){if(ow)ow.classList.add('is-on');if(bth)bth.classList.remove('is-on');}
 else{if(ow)ow.classList.remove('is-on');if(bth)bth.classList.add('is-on');}
 }
 });
});
function initDD(triggerId,listId,items,onSelect,labelFn){
 var trigger=gi(triggerId),list=gi(listId);if(!trigger||!list)return;
 items.forEach(function(item){
 var btn=document.createElement('button');btn.type='button';btn.className='mb-dd-opt';
 btn.textContent=typeof item==='string'?item:item.name;
 btn.addEventListener('click',function(e){
 e.stopPropagation();
 onSelect(item);
 var disp=trigger.querySelector('.mb-dd-val');
 if(disp){disp.textContent=labelFn?labelFn(item):(typeof item==='string'?item:item.name);disp.classList.remove('ph');}
 list.classList.remove('is-on');trigger.classList.remove('is-on');
 });
 list.appendChild(btn);
 });
 trigger.addEventListener('click',function(e){
 e.stopPropagation();
 var wasOn=list.classList.contains('is-on');
 closeAll();
 if(!wasOn){list.classList.add('is-on');trigger.classList.add('is-on');}
 });
}
function buildHeliportDD(listId,excludeId,onSelect){
 var list=gi(listId);if(!list)return;
 var title=list.querySelector('.mb-dd-list-title');
 list.innerHTML='';if(title)list.appendChild(title);
 var isDepList=(listId==='list-h-dep');
 var otherSel=isDepList?ST.heliDest:ST.heliDep;
 var otherObj=HELIPORTS.find(function(h){return h.name===otherSel;});
 var suggestedIds=otherObj&&HELI_SUGGESTIONS[otherObj.id]?HELI_SUGGESTIONS[otherObj.id]:[];
 function makeBtn(h){
 var btn=document.createElement('button');btn.type='button';btn.className='mb-dd-opt';
 btn.style.cssText='display:flex;align-items:center;justify-content:space-between;gap:8px;';
 var nameSpan=document.createElement('span');nameSpan.textContent=h.name;
 var iataSpan=document.createElement('span');
 iataSpan.textContent=h.id;
 iataSpan.style.cssText='font-size:.68rem;font-weight:700;color:#B8A06A;background:rgba(184,160,106,.12);border:1px solid rgba(184,160,106,.3);border-radius:4px;padding:1px 5px;letter-spacing:.08em;flex-shrink:0;';
 btn.appendChild(nameSpan);
 btn.appendChild(iataSpan);
 btn.addEventListener('click',function(e){
 e.stopPropagation();onSelect(h.name);
 list.classList.remove('is-on');
 });
 return btn;
 }
 var suggested=HELIPORTS.filter(function(h){return suggestedIds.indexOf(h.id)>-1&&h.name!==excludeId;});
 var others=HELIPORTS.filter(function(h){return suggestedIds.indexOf(h.id)===-1&&h.name!==excludeId;});
 if(suggested.length){
 var sugHdr=document.createElement('div');
 sugHdr.style.cssText='padding:5px 14px 3px;font-size:9px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#B8A06A;';
 sugHdr.textContent='Suggested routes';
 list.appendChild(sugHdr);
 suggested.forEach(function(h){list.appendChild(makeBtn(h));});
 var sep=document.createElement('div');
 sep.style.cssText='border-top:1px solid rgba(184,160,106,.15);margin:4px 0;';
 list.appendChild(sep);
 var allHdr=document.createElement('div');
 allHdr.style.cssText='padding:5px 14px 3px;font-size:9px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--text3);';
 allHdr.textContent='All heliports';
 list.appendChild(allHdr);
 }
 others.forEach(function(h){list.appendChild(makeBtn(h));});
}
function initHeliDDs(){
 if(gi('trig-h-dep')&&gi('trig-h-dep')._heliInited)return;
 if(gi('trig-h-dep'))gi('trig-h-dep')._heliInited=true;
 var trigDep=gi('trig-h-dep'),listDep=gi('list-h-dep');
 var trigDest=gi('trig-h-dest'),listDest=gi('list-h-dest');
 function onDepSelect(h){
 ST.heliDep=h;var d=trigDep.querySelector('.mb-dd-val');if(d){d.textContent=h;d.classList.remove('ph');}
 trigDep.classList.remove('is-on');
 buildHeliportDD('list-h-dest',h,function(dest){
 ST.heliDest=dest;var d2=trigDest.querySelector('.mb-dd-val');if(d2){d2.textContent=dest;d2.classList.remove('ph');}
 trigDest.classList.remove('is-on');listDest.classList.remove('is-on');
 updateHeliPrices();
 });
 }
 function onDestSelect(h){
 ST.heliDest=h;var d=trigDest.querySelector('.mb-dd-val');if(d){d.textContent=h;d.classList.remove('ph');}
 trigDest.classList.remove('is-on');
 buildHeliportDD('list-h-dep',h,onDepSelect);
 updateHeliPrices();
 }
 buildHeliportDD('list-h-dep','',onDepSelect);
 buildHeliportDD('list-h-dest','',onDestSelect);
 if(trigDep)trigDep.addEventListener('click',function(e){e.stopPropagation();var wasOn=listDep.classList.contains('is-on');closeAll();if(!wasOn){listDep.classList.add('is-on');trigDep.classList.add('is-on');}});
 if(trigDest)trigDest.addEventListener('click',function(e){e.stopPropagation();var wasOn=listDest.classList.contains('is-on');closeAll();if(!wasOn){listDest.classList.add('is-on');trigDest.classList.add('is-on');}});
}
function initTimeDD(triggerId,listId,stateKey,dispId,hoursOverride){
  var trig=gi(triggerId),list=gi(listId);if(!trig||!list)return;
  if(trig._timeInited)return;
  trig._timeInited=true;
  var hours=hoursOverride||[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,0,1,2,3,4,5,6];
  var mins=[0,5,10,15,20,25,30,35,40,45,50,55];
  var curH=hours[0],curM=0;
  function pad(n){return n<10?'0'+n:''+n;}
  function applyTime(){
    var t=pad(curH)+':'+pad(curM);
    ST[stateKey]=t;
    var hidden=gi(triggerId.replace('trig-',''));
    if(hidden&&hidden.type==='hidden')hidden.value=t;
    var d=gi(dispId);
    if(d){d.textContent=t;d.classList.remove('ph');}
  }
  function makeCol(items,getCur,setCur,colEl,closeAfter){
    items.forEach(function(v){
      var btn=document.createElement('button');
      btn.type='button';
      btn.textContent=pad(v);
      var active=getCur()===v;
      btn.style.cssText='display:block;width:100%;padding:9px 0;border:none;cursor:pointer;font-size:15px;font-family:inherit;font-weight:'+(active?'700':'400')+';background:'+(active?'#002f1c':'transparent')+';color:'+(active?'#B8A06A':'#3a3a3a')+';border-radius:5px;text-align:center;line-height:1;box-sizing:border-box;';
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        setCur(v);
        colEl.querySelectorAll('button').forEach(function(b){
          var on=getCur()===parseInt(b.textContent,10);
          b.style.background=on?'#002f1c':'transparent';
          b.style.color=on?'#B8A06A':'#3a3a3a';
          b.style.fontWeight=on?'700':'400';
        });
        applyTime();
        if(closeAfter){
          list.style.display='none';
          trig.classList.remove('is-on');
        }
      });
      colEl.appendChild(btn);
    });
  }
  list.innerHTML='';
  list.style.cssText='display:none;position:absolute;top:calc(100% + 6px);left:0;right:0;z-index:9999;background:#fff;border:1px solid rgba(184,160,106,.3);border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,.15);padding:0;box-sizing:border-box;overflow:hidden;';  var header=document.createElement('div');
  header.style.cssText='display:flex;background:#f9f7f3;border-bottom:1px solid rgba(184,160,106,.2);';
  ['HOUR','MIN'].forEach(function(t,i){
    var d=document.createElement('div');
    d.style.cssText='flex:1;text-align:center;padding:9px 0;font-size:10px;font-weight:700;letter-spacing:.14em;color:#B8A06A;'+(i===0?'border-right:1px solid rgba(184,160,106,.2);':'');
    d.textContent=t;
    header.appendChild(d);
  });
  list.appendChild(header);
  // Body
  var body=document.createElement('div');
  body.style.cssText='display:flex;max-height:220px;';
  var colH=document.createElement('div');
  colH.style.cssText='flex:1;overflow-y:auto;padding:4px;border-right:1px solid rgba(184,160,106,.15);min-width:0;';
  var colM=document.createElement('div');
  colM.style.cssText='flex:1;overflow-y:auto;padding:4px;min-width:0;';
  // Hour: ne ferme PAS — Minute: ferme
  makeCol(hours,function(){return curH;},function(v){curH=v;},colH,false);
  makeCol(mins,function(){return curM;},function(v){curM=v;},colM,true);
  body.appendChild(colH);
  body.appendChild(colM);
  list.appendChild(body);
  list.addEventListener('click',function(e){e.stopPropagation();});
  list.addEventListener('mousedown',function(e){e.stopPropagation();});
  list.addEventListener('touchstart',function(e){e.stopPropagation();},{passive:true});
  trig.addEventListener('click',function(e){
    e.stopPropagation();
    var wasOn=list.style.display==='block';
    closeAll();
    if(!wasOn){
      list.style.display='block';
      trig.classList.add('is-on');
      setTimeout(function(){
        var activeH=colH.querySelector('button[style*="#002f1c"]');
        if(activeH)activeH.scrollIntoView({block:'center'});
        var activeM=colM.querySelector('button[style*="#002f1c"]');
        if(activeM)activeM.scrollIntoView({block:'center'});
      },50);
    }
  });
}
function initBthDurDD(){
 var list=gi('list-bth-dur'),trig=gi('trig-bth-dur');
 if(!list||!trig)return;
 if(trig._bthInited)return;
 trig._bthInited=true;
 document.body.appendChild(list);
 // Styles position fixed — via propriétés individuelles (jamais cssText)
 list.style.position='fixed';
 list.style.zIndex='99999';
 list.style.background='#fff';
 list.style.border='1px solid rgba(184,160,106,.3)';
 list.style.borderRadius='12px';
 list.style.boxShadow='0 8px 32px rgba(0,0,0,.15)';
 list.style.padding='0';
 list.style.boxSizing='border-box';
 list.style.overflow='hidden';
 list.style.fontFamily='inherit';
 list.style.display='none';
 list.style.minWidth='160px';
 // Rebuild content
 list.innerHTML='';
 var hdr=document.createElement('div');
 hdr.style.cssText='display:flex;background:#f9f7f3;border-bottom:1px solid rgba(184,160,106,.2);';
 var hLbl=document.createElement('div');
 hLbl.style.cssText='flex:1;text-align:center;padding:9px 0;font-size:10px;font-weight:700;letter-spacing:.14em;color:#B8A06A;';
 hLbl.textContent='DURATION';
 hdr.appendChild(hLbl);list.appendChild(hdr);
 var bdy=document.createElement('div');
 bdy.style.cssText='max-height:220px;overflow-y:auto;';
 Object.keys(BTH_KM).forEach(function(h){
  var btn=document.createElement('button');btn.type='button';
  btn.textContent=h+'H';
  btn.style.cssText='display:block;width:100%;padding:9px 0;border:none;cursor:pointer;font-size:15px;font-family:inherit;font-weight:400;background:transparent;color:#3a3a3a;text-align:center;line-height:1;box-sizing:border-box;';
  btn.addEventListener('click',function(e){
   e.stopPropagation();
   bdy.querySelectorAll('button').forEach(function(b){b.style.background='transparent';b.style.color='#3a3a3a';b.style.fontWeight='400';});
   btn.style.background='#002f1c';btn.style.color='#B8A06A';btn.style.fontWeight='700';
   var disp=gi('disp-bth-dur');if(disp){disp.textContent=h+'H — '+BTH_KM[h]+' km included';disp.classList.remove('ph');}
   var hidden=gi('bth-hours');if(hidden)hidden.value=h;
   list.style.display='none';
   trig.classList.remove('is-on');
  });
  bdy.appendChild(btn);
 });
 list.appendChild(bdy);
 trig.addEventListener('click',function(e){
  e.stopPropagation();
  var isOpen2=list.style.display==='block';
  closeAll();
  // Restaurer position:fixed après closeAll (qui met display:none via style)
  list.style.position='fixed';
  if(isOpen2){
   list.style.display='none';
   trig.classList.remove('is-on');
  } else {
   var rect=trig.getBoundingClientRect();
   list.style.top=rect.bottom+'px';
   list.style.left=rect.left+'px';
   list.style.width=Math.max(rect.width,160)+'px';
   list.style.display='block';
   trig.classList.add('is-on');
  }
 });
}

function initDatePicker(triggerId,listId,hiddenId,dispId,onChangeCb){
  var trig=gi(triggerId),list=gi(listId);if(!trig||!list)return;
  if(trig._dateInited)return;trig._dateInited=true;
  var MONTHS=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  var DAYS=['L','M','M','J','V','S','D'];
  var today=new Date();var curY=today.getFullYear(),curM=today.getMonth(),selY=null,selM=null,selD=null;
  function pad(n){return n<10?'0'+n:''+n;}
  function applyDate(){var iso=selY+'-'+pad(selM+1)+'-'+pad(selD);var hidden=gi(hiddenId);if(hidden)hidden.value=iso;var d=gi(dispId);if(d){d.textContent=pad(selD)+'/'+pad(selM+1)+'/'+selY;d.classList.remove('ph');}if(onChangeCb)onChangeCb();}
  function render(){
    list.innerHTML='';list.style.cssText='display:block;position:absolute;top:calc(100% + 6px);left:0;right:0;z-index:9999;background:#fff;border:1px solid rgba(184,160,106,.3);border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,.15);padding:0;box-sizing:border-box;overflow:hidden;min-width:280px;font-family:inherit;';
    var hdr=document.createElement('div');hdr.style.cssText='display:flex;align-items:center;justify-content:space-between;background:#f9f7f3;border-bottom:1px solid rgba(184,160,106,.2);padding:10px 14px;';
    var btnP=document.createElement('button');btnP.type='button';btnP.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B8A06A" stroke-width="2.5" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg>';btnP.style.cssText='background:none;border:none;cursor:pointer;padding:2px 6px;display:flex;align-items:center;';btnP.addEventListener('click',function(e){e.stopPropagation();curM--;if(curM<0){curM=11;curY--;}render();});
    var lbl=document.createElement('div');lbl.style.cssText='font-size:13px;font-weight:700;letter-spacing:.06em;color:#B8A06A;text-transform:uppercase;';lbl.textContent=MONTHS[curM]+' '+curY;
    var btnN=document.createElement('button');btnN.type='button';btnN.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B8A06A" stroke-width="2.5" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg>';btnN.style.cssText='background:none;border:none;cursor:pointer;padding:2px 6px;display:flex;align-items:center;';btnN.addEventListener('click',function(e){e.stopPropagation();curM++;if(curM>11){curM=0;curY++;}render();});
    hdr.appendChild(btnP);hdr.appendChild(lbl);hdr.appendChild(btnN);list.appendChild(hdr);
    var wk=document.createElement('div');wk.style.cssText='display:grid;grid-template-columns:repeat(7,1fr);background:#f9f7f3;border-bottom:1px solid rgba(184,160,106,.12);';
    DAYS.forEach(function(d){var c=document.createElement('div');c.style.cssText='text-align:center;padding:6px 0;font-size:10px;font-weight:700;letter-spacing:.1em;color:#B8A06A;';c.textContent=d;wk.appendChild(c);});list.appendChild(wk);
    var grid=document.createElement('div');grid.style.cssText='display:grid;grid-template-columns:repeat(7,1fr);padding:6px;gap:2px;';
    var first=new Date(curY,curM,1).getDay();var startOffset=(first===0)?6:first-1;var daysInMonth=new Date(curY,curM+1,0).getDate();
    for(var i=0;i<startOffset;i++){grid.appendChild(document.createElement('div'));}
    for(var d=1;d<=daysInMonth;d++){(function(day){var btn=document.createElement('button');btn.type='button';btn.textContent=day;var isToday=(day===today.getDate()&&curM===today.getMonth()&&curY===today.getFullYear());var isSel=(selD===day&&selM===curM&&selY===curY);btn.style.cssText='border:none;cursor:pointer;border-radius:6px;padding:8px 0;font-size:14px;font-family:inherit;text-align:center;width:100%;box-sizing:border-box;background:'+(isSel?'#002f1c':'transparent')+';color:'+(isSel?'#B8A06A':(isToday?'#B8A06A':'#3a3a3a'))+';font-weight:'+(isSel||isToday?'700':'400')+';border:'+(isToday&&!isSel?'1px solid rgba(184,160,106,.4)':'1px solid transparent')+';';btn.addEventListener('mouseenter',function(){if(!isSel)this.style.background='rgba(184,160,106,.1)';});btn.addEventListener('mouseleave',function(){if(!isSel)this.style.background='transparent';});btn.addEventListener('click',function(e){e.stopPropagation();selD=day;selM=curM;selY=curY;applyDate();list.style.display='none';trig.classList.remove('is-on');});grid.appendChild(btn);})(d);}
    list.appendChild(grid);
    var footer=document.createElement('div');footer.style.cssText='display:flex;justify-content:space-between;padding:8px 14px;border-top:1px solid rgba(184,160,106,.15);background:#f9f7f3;';
    var btnC=document.createElement('button');btnC.type='button';btnC.textContent='Effacer';btnC.style.cssText='background:none;border:none;cursor:pointer;font-size:13px;font-weight:600;color:#B8A06A;font-family:inherit;';btnC.addEventListener('click',function(e){e.stopPropagation();selD=null;var hidden=gi(hiddenId);if(hidden)hidden.value='';var d=gi(dispId);if(d){d.textContent='jj/mm/aaaa';d.classList.add('ph');}list.style.display='none';trig.classList.remove('is-on');});
    var btnT=document.createElement('button');btnT.type='button';btnT.textContent="Aujourd'hui";btnT.style.cssText='background:none;border:none;cursor:pointer;font-size:13px;font-weight:600;color:#B8A06A;font-family:inherit;';btnT.addEventListener('click',function(e){e.stopPropagation();selD=today.getDate();selM=today.getMonth();selY=today.getFullYear();curM=selM;curY=selY;applyDate();list.style.display='none';trig.classList.remove('is-on');});
    footer.appendChild(btnC);footer.appendChild(btnT);list.appendChild(footer);
  }
  trig.addEventListener('click',function(e){e.stopPropagation();var wasOn=list.style.display==='block';closeAll();if(!wasOn){render();trig.classList.add('is-on');}});
}

function buildLocDD(ddEl,items,iconSvg,onSelect){
 ddEl.innerHTML='<div class="mb-loc-dd-title">'+iconSvg+'</div>';
 items.forEach(function(item){
 var btn=document.createElement('button');btn.type='button';btn.className='mb-loc-dd-opt';
 btn.innerHTML='<span class="mb-loc-dd-code">'+item.code+'</span><span>'+item.name+'</span>';
 btn.addEventListener('mousedown',function(e){
 e.preventDefault();
 onSelect(item);
 ddEl.classList.remove('is-on');
 });
 ddEl.appendChild(btn);
 });
}
function showLocCond(fieldId,type){
 var af=gi('af-'+fieldId),tf=gi('tf-'+fieldId);
 if(af)af.classList.toggle('is-on',type==='airport');
 if(tf)tf.classList.toggle('is-on',type==='train');
 ST.pickupType=type; 
}
function clearLocCond(fieldId){
 var af=gi('af-'+fieldId),tf=gi('tf-'+fieldId);
 if(af)af.classList.remove('is-on');
 if(tf)tf.classList.remove('is-on');
 ST.pickupType=null;
}
function initLocField(inputId,ddId,apBtnId,trBtnId,condFieldId,showAirportCond){
 var input=gi(inputId),dd=gi(ddId);
 var apBtn=apBtnId?gi(apBtnId):null;
 var trBtn=trBtnId?gi(trBtnId):null;
 if(!input||!dd)return;
 var svgAp='<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg> Airports';
 var svgTr='<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="4" y="3" width="16" height="13" rx="2"/><path d="M4 11h16"/></svg> Train stations';
 var _lockedType=null; 
 var _ignoreInput=false; 
 if(apBtn){
 apBtn.addEventListener('click',function(e){
 e.stopPropagation();
 var wasOn=dd.classList.contains('is-on')&&apBtn.classList.contains('is-on');
 closeAll();
 if(!wasOn){
 apBtn.classList.add('is-on');
 buildLocDD(dd,AIRPORTS,svgAp,function(item){
 _ignoreInput=true;
 input.value=item.name;
 _lockedType='airport';
 if(condFieldId&&showAirportCond)showLocCond(condFieldId,'airport');
 dd.classList.remove('is-on');apBtn.classList.remove('is-on');
 setTimeout(function(){_ignoreInput=false;},100);
 });
 dd.classList.add('is-on');
 }
 });
 }
 if(trBtn){
 trBtn.addEventListener('click',function(e){
 e.stopPropagation();
 var wasOn=dd.classList.contains('is-on')&&trBtn.classList.contains('is-on');
 closeAll();
 if(!wasOn){
 trBtn.classList.add('is-on');
 buildLocDD(dd,TRAINS,svgTr,function(item){
 _ignoreInput=true;
 input.value=item.name;
 _lockedType='train';
 if(condFieldId)showLocCond(condFieldId,'train');
 dd.classList.remove('is-on');trBtn.classList.remove('is-on');
 setTimeout(function(){_ignoreInput=false;},100);
 });
 dd.classList.add('is-on');
 }
 });
 }
 input.addEventListener('input',function(){
 if(_ignoreInput)return;
 _lockedType=null;
 if(condFieldId)clearLocCond(condFieldId);
 });
 if(input._acListener)return; 
 input._acListener=true;
 input.addEventListener('blur',function(){
 if(!input.value.trim()&&condFieldId){_lockedType=null;clearLocCond(condFieldId);}
 });
}
function initPaxPanel(triggerId,panelId){
 var trig=gi(triggerId),panel=gi(panelId);if(!trig||!panel)return;
 trig.addEventListener('click',function(e){
 e.stopPropagation();
 var wasOn=panel.classList.contains('is-on');
 closeAll();
 if(!wasOn){panel.classList.add('is-on');trig.classList.add('is-on');}
 });
}
document.addEventListener('click',function(e){
 var btn=e.target.closest('.mb-ctr-btn');
 if(btn){
 e.stopPropagation();
 var ref=btn.getAttribute('data-ref');if(!ref)return;
 var valEl=gi(ref+'-v');if(!valEl)return;
 var cur=parseInt(valEl.textContent)||0;
 var isPlus=btn.hasAttribute('data-plus');
 var min=parseInt(btn.getAttribute('data-min')||'0');
 valEl.textContent=isPlus?cur+1:Math.max(min,cur-1);
 updatePaxDisplay(ref);
 return;
 }
 var t=e.target;
 var inPac=false;
 while(t){if(t.classList&&(t.classList.contains('pac-container')||t.classList.contains('pac-item'))){inPac=true;break;}t=t.parentElement;}
 var inTimePicker=false;
 document.querySelectorAll('.mb-dd-list').forEach(function(el){
   if(el.style.display==='block'&&el.style.position==='fixed'){
     var r=el.getBoundingClientRect();
     if(e.clientX>=r.left&&e.clientX<=r.right&&e.clientY>=r.top&&e.clientY<=r.bottom) inTimePicker=true;
   }
 });
 if(!inPac&&!inTimePicker&&!e.target.closest('.mb-svc-card')&&!e.target.closest('.mb-sub-card')&&!e.target.closest('.mb-phone-dd')&&!e.target.closest('.mb-dd-wrap')&&!e.target.closest('.mb-pax-panel')&&!e.target.closest('.mb-pax-trigger')){
  closeAll();
 }
});
function updatePaxDisplay(ref){
 var parts=ref.split('-');
 var prefix=parts[0];
 if(!window.ST_PAX_TOUCHED) window.ST_PAX_TOUCHED={};
 if(!window.ST_BAG_TOUCHED) window.ST_BAG_TOUCHED={};
 var isPax=['adults','children','babies','pets'].some(function(k){return ref.indexOf(k)>-1;});
 var isBag=['cabin','hold','special'].some(function(k){return ref.indexOf(k)>-1;});
 if(isPax) window.ST_PAX_TOUCHED[prefix]=true;
 if(isBag) window.ST_BAG_TOUCHED[prefix]=true;
 var paxKeys=[prefix+'-adults',prefix+'-children',prefix+'-babies',prefix+'-pets'];
 var paxNames=['adult','child','baby','pet'];
 var paxParts=[];
 var totalAdults=0;
 paxKeys.forEach(function(k,i){var el=gi(k+'-v');if(el){var n=parseInt(el.textContent)||0;if(i===0)totalAdults=n;if(n>0)paxParts.push(n+' '+paxNames[i]+(n>1&&i<3?'s':''));}});
 var pDisp=gi('disp-'+prefix+'-pax');
 if(pDisp){
 if(paxParts.length){pDisp.textContent=paxParts.join(', ');pDisp.classList.remove('ph');}
 else{pDisp.textContent='Add passengers';pDisp.classList.add('ph');}
 }
 ST['pax_'+prefix+'_adults']=totalAdults;
 var bagKeys=[prefix+'-cabin',prefix+'-hold',prefix+'-special'];
 var bagNames=['cabin bag','hold bag','special'];
 var bagParts=[];
 var totalBags=0;
 bagKeys.forEach(function(k,i){var el=gi(k+'-v');if(el){var n=parseInt(el.textContent)||0;totalBags+=n;if(n>0)bagParts.push(n+' '+bagNames[i]+(n>1&&i<2?'s':''));}});
 var bDisp=gi('disp-'+prefix+'-bag');
 if(bDisp){
 if(bagParts.length){bDisp.textContent=bagParts.join(', ');bDisp.classList.remove('ph');}
 else if(window.ST_BAG_TOUCHED[prefix]){bDisp.textContent='No luggage';bDisp.classList.remove('ph');}
 else{bDisp.textContent='Add luggage';bDisp.classList.add('ph');}
 }
}
function initStops(addBtnId,containerId,prefix){
 var btn=gi(addBtnId);if(!btn)return;
 btn.addEventListener('click',function(){
 ST['stopCnt'+prefix]=(ST['stopCnt'+prefix]||0)+1;
 var n=ST['stopCnt'+prefix];
 var wrap=document.createElement('div');wrap.className='mb-stop';wrap.setAttribute('data-stop-wrap','1');
 var inner=document.createElement('div');inner.className='mb-stop-inner';
 var inp=document.createElement('input');inp.type='text';inp.id='stop-'+prefix+'-'+n;inp.placeholder='Stop '+n+' — address, hotel…';inp.autocomplete='off';
 var rm=document.createElement('button');rm.type='button';rm.className='mb-stop-rm';rm.textContent='×';
 rm.addEventListener('click',function(){wrap.remove();});
 inner.appendChild(inp);inner.appendChild(rm);wrap.appendChild(inner);
 gi(containerId).appendChild(wrap);
 if(typeof google!=='undefined'&&google.maps&&google.maps.places){
 var ac=new google.maps.places.Autocomplete(inp,{types:['establishment','geocode'],bounds:new google.maps.LatLngBounds(new google.maps.LatLng(42,2),new google.maps.LatLng(51.5,8.5)),strictBounds:false});
 ac.addListener('place_changed',function(){
 var pl=ac.getPlace();
 if(pl&&pl.formatted_address)inp.value=pl.formatted_address;
 else if(pl&&pl.name)inp.value=pl.name;
 if(id==='ow-from'||id==='bth-pickup'){
 var v2=(inp.value||'').toLowerCase();
 var isAp=AIRPORTS.some(function(a){return v2.indexOf(a.name.toLowerCase())>-1||v2.indexOf(a.code.toLowerCase())>-1;});
 var isTr=TRAINS.some(function(t){return v2.indexOf(t.name.toLowerCase())>-1||v2.indexOf(t.code.toLowerCase())>-1;});
 var types=pl&&pl.types?pl.types:[];
 if(types.indexOf('airport')>-1)isAp=true;
 if(types.indexOf('train_station')>-1||types.indexOf('transit_station')>-1)isTr=true;
 var condId=id==='ow-from'?'ow-from':'bth';
 if(isAp){showLocCond(condId,'airport');}
 else if(isTr){showLocCond(condId,'train');}
 else{clearLocCond(condId);}
 }
 setTimeout(function(){inp.blur();},10);
 });
 }
 });
}
function initReturnToggle(btnId,wrapId,stateKey){
 var btn=gi(btnId),wrap=gi(wrapId);if(!btn||!wrap)return;
 btn.addEventListener('click',function(){
 ST[stateKey]=!ST[stateKey];
 wrap.style.display=ST[stateKey]?'block':'none';
 var svgAdd='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';
 var svgRm='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
 btn.innerHTML=(ST[stateKey]?svgRm+' Remove return':svgAdd+' Add a return');
 });
}
[['ow-seats-cb','ow-seats-wrap'],['bth-seats-cb','bth-seats-wrap']].forEach(function(pair){
 var cb=gi(pair[0]),wrap=gi(pair[1]);if(!cb||!wrap)return;
 cb.addEventListener('change',function(){wrap.classList.toggle('is-on',cb.checked);});
});
var PRIORITY_NAMES=['United States','United Kingdom','France','Belgium','Italy','United Arab Emirates','Saudi Arabia'];
function buildPhoneListIn(listEl,onSelect){
 if(!listEl)return;listEl.innerHTML='';
 var priority=PRIORITY_NAMES.map(function(name){return ALL_COUNTRIES.find(function(c){return c.n===name;});}).filter(Boolean);
 var priorityNames=priority.map(function(c){return c.n;});
 var rest=ALL_COUNTRIES.filter(function(c){return priorityNames.indexOf(c.n)===-1;});
 function makeBtn(c){
 var btn=document.createElement('button');btn.type='button';btn.className='mb-phone-opt';
 btn.textContent=c.f+' '+c.n+' ('+c.c+')';
 btn.addEventListener('click',function(){onSelect(c);});
 return btn;
 }
 priority.forEach(function(c){listEl.appendChild(makeBtn(c));});
 var sep=document.createElement('div');
 sep.style.cssText='height:1px;background:rgba(184,160,106,.2);margin:4px 0;';
 listEl.appendChild(sep);
 rest.forEach(function(c){listEl.appendChild(makeBtn(c));});
}
function buildPhoneList(){
 buildPhoneListIn(gi('phone-list'),function(c){
 ST.phone={code:c.c,flag:c.f,ph:c.p};
 var f=gi('phone-flag'),cd=gi('phone-code'),inp=gi('ct-phone');
 if(f)f.textContent=c.f;if(cd)cd.textContent=c.c;if(inp)inp.placeholder=c.p;
 gi('phone-dd').classList.remove('is-on');gi('phone-err').textContent='';
 });
}
var phoneFlagBtn=gi('phone-flag-btn');
if(phoneFlagBtn)phoneFlagBtn.addEventListener('click',function(e){e.stopPropagation();var dd=gi('phone-dd');var wasOn=dd.classList.contains('is-on');closeAll();if(!wasOn)dd.classList.add('is-on');});
var phoneSearch=gi('phone-search');
if(phoneSearch){
 phoneSearch.addEventListener('click',function(e){e.stopPropagation();});
 phoneSearch.addEventListener('focus',function(e){e.stopPropagation();});
 phoneSearch.addEventListener('input',function(){var t=phoneSearch.value.toLowerCase();gi('phone-list').querySelectorAll('.mb-phone-opt').forEach(function(b){b.style.display=b.textContent.toLowerCase().includes(t)?'':'none';});});
}
var ctPhone=gi('ct-phone');
if(ctPhone){
 ctPhone.addEventListener('keydown',function(e){
 var allowed=[8,9,13,27,32,35,36,37,38,39,40,46];
 if(allowed.indexOf(e.keyCode)>-1)return;
 if(e.key==='+')return;
 if(e.key==='-'||e.key===' ')return;
 if(e.key>='0'&&e.key<='9')return;
 if(e.ctrlKey||e.metaKey)return;
 e.preventDefault();
 });
 ctPhone.addEventListener('paste',function(e){
 var pasted=(e.clipboardData||window.clipboardData).getData('text');
 e.preventDefault();
 var clean=pasted.replace(/[^\d\s\+\-]/g,'');
 var s=ctPhone.selectionStart;
 ctPhone.value=ctPhone.value.slice(0,s)+clean+ctPhone.value.slice(ctPhone.selectionEnd);
 ctPhone.selectionStart=ctPhone.selectionEnd=s+clean.length;
 });
 ctPhone.addEventListener('input',function(){
 var v=ctPhone.value,cleaned=v.replace(/[^\d\s\+\-]/g,'');
 if(cleaned!==v){var s=ctPhone.selectionStart-(v.length-cleaned.length);ctPhone.value=cleaned;ctPhone.selectionStart=ctPhone.selectionEnd=Math.max(0,s);}
 var phoneErr=gi('phone-err');
 var phoneWrap=ctPhone.closest('.mb-phone');
 if(phoneErr)phoneErr.innerHTML='';
 if(phoneWrap)phoneWrap.style.borderColor='';
 });
}
var billCb=gi('bill-toggle'),billFields=gi('bill-fields');
if(billCb&&billFields)billCb.addEventListener('change',function(){billFields.classList.toggle('is-on',billCb.checked);});
var otherCb=gi('other-toggle'),otherFields=gi('other-fields');
if(otherCb&&otherFields){
 otherCb.addEventListener('change',function(){
 otherFields.style.display=otherCb.checked?'block':'none';
 });
}
var paxPhoneState={code:'+33',flag:'🇫🇷',ph:'6 12 34 56 78'};
function buildPaxPhoneList(){
 buildPhoneListIn(gi('pax-phone-list'),function(c){
 paxPhoneState={code:c.c,flag:c.f,ph:c.p};
 var f=gi('pax-phone-flag'),cd=gi('pax-phone-code'),inp=gi('pax-phone');
 if(f)f.textContent=c.f;if(cd)cd.textContent=c.c;if(inp)inp.placeholder=c.p;
 gi('pax-phone-dd').classList.remove('is-on');gi('pax-phone-err').textContent='';
 });
}
var paxFlagBtn=gi('pax-phone-flag-btn');
if(paxFlagBtn)paxFlagBtn.addEventListener('click',function(e){
 e.stopPropagation();
 var dd=gi('pax-phone-dd');var wasOn=dd.classList.contains('is-on');
 closeAll();if(!wasOn)dd.classList.add('is-on');
});
var paxSearch=gi('pax-phone-search');
if(paxSearch){
 paxSearch.addEventListener('click',function(e){e.stopPropagation();});
 paxSearch.addEventListener('focus',function(e){e.stopPropagation();});
 paxSearch.addEventListener('input',function(){
 var t=paxSearch.value.toLowerCase();
 gi('pax-phone-list').querySelectorAll('.mb-phone-opt').forEach(function(b){
 b.style.display=b.textContent.toLowerCase().includes(t)?'':'none';
 });
 });
}
var paxPhoneInp=gi('pax-phone');
if(paxPhoneInp){
 paxPhoneInp.addEventListener('keydown',function(e){
 var allowed=[8,9,13,27,32,35,36,37,38,39,40,46];
 if(allowed.indexOf(e.keyCode)>-1)return;
 if(e.key==='+')return;if(e.key==='-'||e.key===' ')return;
 if(e.key>='0'&&e.key<='9')return;if(e.ctrlKey||e.metaKey)return;
 e.preventDefault();
 });
 paxPhoneInp.addEventListener('input',function(){
 var v=paxPhoneInp.value,cleaned=v.replace(/[^\d\s\+\-]/g,'');
 if(cleaned!==v){var s=paxPhoneInp.selectionStart-(v.length-cleaned.length);paxPhoneInp.value=cleaned;paxPhoneInp.selectionStart=paxPhoneInp.selectionEnd=Math.max(0,s);}
 var e2=gi('pax-phone-err'),w2=gi('pax-phone-wrap');
 if(e2)e2.innerHTML='';if(w2)w2.style.borderColor='';
 });
}
buildPaxPhoneList();
function buildTrustBadges(){
 var sidebar=gi('veh-trust-sidebar');if(!sidebar)return;
 sidebar.innerHTML='';
 var pickupType=ST.pickupType; 
 var waitTitle='', waitSub='';
 if(pickupType==='airport'){
 waitTitle='Free waiting time*';
 waitSub='60 min for commercial flights (from landing). 30 min for private aviation.';
 } else if(pickupType==='train'){
 waitTitle='Free waiting time';
 waitSub='30 min included once your train is on the platform.';
 } else {
 waitTitle='Free waiting time';
 waitSub='20 min complimentary waiting time included.';
 }
 var badges=[
 {icon:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>',title:'Professional chauffeur',sub:'Suit & tie. Discreet, punctual and fluent in English.'},
 {icon:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>',title:'Free cancellation',sub:'Up to 48 hours in advance.'},
 {icon:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>',title:'Fixed price',sub:'No hidden fees. The price you see is the price you pay.'},
 {icon:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>',title:waitTitle,sub:waitSub}
 ];
 badges.forEach(function(b){
 var el=document.createElement('div');
 el.className='mb-trust-badge';
 el.innerHTML='<div class="mb-trust-badge-ic">'+b.icon+'</div>'
 +'<div class="mb-trust-badge-txt">'
 +'<div class="mb-trust-badge-title">'+b.title+'</div>'
 +(b.sub?'<div class="mb-trust-badge-sub">'+b.sub+'</div>':'')
 +'</div>';
 sidebar.appendChild(el);
 });
}
function buildVehCards(){
 var c=gi('veh-grid');if(!c)return;c.innerHTML='';
 var from=ST.sub==='one-way'?val('ow-from'):val('bth-pickup');
 var to=ST.sub==='one-way'?val('ow-to'):'';
 buildTrustBadges();
 VEHICLES.forEach(function(v){
 var card=document.createElement('div');card.className='mb-veh-card'+(ST.selVeh===v.id?' is-on':'');
 var imgCount=v.images?v.images.length:0;
 var imgHtml=imgCount?'<div class="mb-veh-img-wrap" style="position:relative;width:100%;height:260px;overflow:hidden;border-radius:var(--rsm) var(--rsm) 0 0;">'+(v.images.map(function(src,ii){return'<img src="'+src+'" class="mb-veh-slide" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;display:block;transition:opacity .4s;opacity:'+(ii===0?'1':'0')+';">';}).join(''))+(imgCount>1?'<div class="mb-img-dots" style="position:absolute;bottom:8px;left:0;right:0;display:flex;justify-content:center;gap:5px;z-index:2;">'+(v.images.map(function(_,ii){return'<span class="mb-img-dot" data-idx="'+ii+'" style="width:6px;height:6px;border-radius:50%;background:'+(ii===0?'#fff':'rgba(255,255,255,.45)')+';cursor:pointer;transition:background .2s;"></span>';}).join(''))+'</div>':'')+'</div>':'<div style="width:100%;height:260px;overflow:hidden;border-radius:var(--rsm) var(--rsm) 0 0;background:linear-gradient(160deg,#1a1c1e 0%,#0d0d0f 100%);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#B8A06A" stroke-width="1.2" stroke-linecap="round" opacity=".6"><path d="M19 17H5a2 2 0 0 1-2-2v-4l3-6h12l3 6v4a2 2 0 0 1-2 2z"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="16.5" cy="17.5" r="2.5"/></svg><span style="font-size:.65rem;color:#B8A06A;letter-spacing:.12em;text-transform:uppercase;opacity:.7;">Photo coming soon</span></div>';
 
 card.innerHTML='<div class="mb-veh-chk"><svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="1,6 5,10 11,2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'+imgHtml+'<div class="mb-veh-body"><div class="mb-veh-top"><div><div class="mb-veh-name">'+v.name+'</div><div class="mb-veh-sub">'+v.sub+'</div></div>'+(v.badge?'<div class="mb-badge-pill">'+v.badge+'</div>':'')+'</div><div class="mb-spec-row"><span class="mb-spec" style="font-size:13px;padding:5px 12px;">'+v.pax+' pax</span><span class="mb-spec" style="font-size:13px;padding:5px 12px;">'+v.luggage+'</span><span class="mb-spec" style="font-size:13px;padding:5px 12px;">'+v.feat+'</span></div><div class=\"mb-spec-row\" style=\"margin-top:6px;gap:4px;\"><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2C6 9 4 13 4 16a8 8 0 0016 0c0-3-2-7-8-14z"/></svg> Water</span><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="8" width="18" height="10" rx="4"/><path d="M7 8V5a2 2 0 014 0v3M13 8V5a2 2 0 014 0v3"/></svg> Oshibori</span><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="6" y="2" width="12" height="18" rx="2"/><path d="M10 8l2-3 2 3h-1.5v3H11.5V8H10z" stroke="none" fill="currentColor"/><line x1="12" y1="17" x2="12" y2="17.5"/></svg> Chargers</span><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12.55a11 11 0 0114.08 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor" stroke="none"/></svg> WiFi</span><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7"/></svg> Umbrella</span><span class=\"mb-spec\" style=\"font-size:10.5px;padding:3px 7px;background:rgba(184,160,106,.06);border-color:rgba(184,160,106,.15);display:inline-flex;align-items:center;gap:4px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2C8 2 5 5 5 9v9a2 2 0 002 2h10a2 2 0 002-2V9c0-4-3-7-7-7z"/><path d="M9 12c0-1.66 1.34-3 3-3s3 1.34 3 3"/></svg> Tissues</span></div></div>';
 card.addEventListener('click',function(){c.querySelectorAll('.mb-veh-card').forEach(function(x){x.classList.remove('is-on');});card.classList.add('is-on');ST.selVeh=v.id;});
 c.appendChild(card);
 });
}
function buildHeliCards(){
 var c=gi('heli-grid');if(!c)return;c.innerHTML='';
 HELICOPTERS.forEach(function(h){
 var card=document.createElement('div');card.className='mb-heli-card'+(ST.selHeli===h.id?' is-on':'');
 var hImgCount=h.images?h.images.length:0;
 var imgHtml=hImgCount
  ?'<div class="mb-heli-img-wrap" style="position:relative;width:100%;height:220px;overflow:hidden;border-radius:var(--rsm) var(--rsm) 0 0;">'
   +(h.images.map(function(src,ii){return'<img src="'+src+'" class="mb-heli-slide" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;transition:opacity .4s;opacity:'+(ii===0?'1':'0')+';">';}).join(''))
   +(hImgCount>1
    ?'<button class="mb-slide-prev" type="button" style="position:absolute;left:8px;top:50%;transform:translateY(-50%);z-index:3;background:#B8A06A;border:none;border-radius:50%;width:28px;height:28px;cursor:pointer;display:flex;align-items:center;justify-content:center;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#002f1c" stroke-width="3" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg></button>'
    +'<button class="mb-slide-next" type="button" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);z-index:3;background:#B8A06A;border:none;border-radius:50%;width:28px;height:28px;cursor:pointer;display:flex;align-items:center;justify-content:center;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#002f1c" stroke-width="3" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg></button>'
    +'<div style="position:absolute;bottom:8px;left:0;right:0;display:flex;justify-content:center;gap:5px;z-index:2;">'+(h.images.map(function(_,ii){return'<span class="mb-img-dot" data-idx="'+ii+'" style="width:7px;height:7px;border-radius:50%;background:'+(ii===0?'#B8A06A':'rgba(255,255,255,.45)')+';cursor:pointer;transition:all .2s;transform:'+(ii===0?'scale(1.2)':'scale(1)')+';"></span>';}).join(''))+'</div>'
    :'')
   +'</div>'
  :'<div style="width:100%;height:220px;border-radius:var(--rsm) var(--rsm) 0 0;background:linear-gradient(160deg,#1a1c1e 0%,#0d0d0f 100%);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;"><svg width="40" height="40" viewBox="0 0 80 80" fill="none" opacity=".25"><path d="M55 36C55 36 50 28 38 27C26 26 16 33 16 33" stroke="#B8A06A" stroke-width="3" stroke-linecap="round"/><circle cx="38" cy="34" r="4" fill="#B8A06A"/><path d="M55 36L61 33.5L59.5 39L65 41" stroke="#B8A06A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size:.6rem;color:#B8A06A;letter-spacing:.12em;text-transform:uppercase;opacity:.7;">Photo coming soon</span></div>';
 var specIcons={pax:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>',bag:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>',speed:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2a10 10 0 100 20A10 10 0 0012 2z"/><path d="M12 6v6l4 2"/></svg>'};
 card.innerHTML=imgHtml
  +(h.badge?'<div style="position:absolute;top:12px;left:12px;background:var(--gold);color:var(--dark);font-size:.6rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:3px 10px;border-radius:999px;z-index:3;">'+h.badge+'</div>':'')
  +'<div class="mb-heli-chk"><svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="1,6 5,10 11,2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
  +'<div class="mb-heli-body">'
   +'<div class="mb-heli-name">'+h.name+'</div>'
   +'<div class="mb-heli-sub">'+h.sub+'</div>'
   +'<div class="mb-spec-row" style="margin-bottom:10px;">'
    +'<span class="mb-heli-spec">'+specIcons.pax+' '+h.pax+' pax</span>'
    +'<span class="mb-heli-spec">'+specIcons.bag+' '+h.luggage+'</span>'
    +'<span class="mb-heli-spec">'+specIcons.speed+' '+h.speed+' km/h</span>'
   +'</div>'
   +'<div style="font-size:13px;color:var(--text2);line-height:1.5;margin-bottom:12px;">'+h.desc+'</div>'
   +'<div class="mb-heli-price rq" id="hprice-'+h.id+'" style="border:1px solid var(--field-bd);border-radius:var(--rxs);padding:10px 14px;text-align:right;background:var(--white);">Price on request</div>'
  +'</div>';
 if(hImgCount>1){
  var _wrap=card.querySelector('.mb-heli-img-wrap');
  var _slides=card.querySelectorAll('.mb-heli-slide');
  var _dots=card.querySelectorAll('.mb-img-dot');
  var _cur=0;
  function _goTo(n){n=(n+hImgCount)%hImgCount;_slides.forEach(function(s,i){s.style.opacity=i===n?'1':'0';});_dots.forEach(function(d,i){d.style.background=i===n?'#B8A06A':'rgba(255,255,255,.45)';d.style.transform=i===n?'scale(1.2)':'scale(1)';});_cur=n;}
  var _bp=card.querySelector('.mb-slide-prev');var _bn=card.querySelector('.mb-slide-next');
  if(_bp)_bp.addEventListener('click',function(e){e.stopPropagation();_goTo(_cur-1);});
  if(_bn)_bn.addEventListener('click',function(e){e.stopPropagation();_goTo(_cur+1);});
  _dots.forEach(function(d,i){d.addEventListener('click',function(e){e.stopPropagation();_goTo(i);});});
 }
 card.addEventListener('click',function(){c.querySelectorAll('.mb-heli-card').forEach(function(x){x.classList.remove('is-on');});card.classList.add('is-on');ST.selHeli=h.id;});
 c.appendChild(card);
 });
}
function loadHeliPrices(){
 try{fetch(window.LL_HELI_PRICES_URL||'/cdn/shop/files/helicopter-prices.json').then(function(r){return r.json();}).then(function(d){ST.pricesData=d;updateHeliPrices();}).catch(function(){});}catch(e){}
}
function normalizeHeliport(s){return s?s.toLowerCase().replace(/[-–—]/g,' ').replace(/\s+/g,' ').trim():'';}
function findRoute(routes,dep,dest){if(routes[dep]&&routes[dep][dest])return routes[dep][dest];var nd=normalizeHeliport(dep),nt=normalizeHeliport(dest);var dk=Object.keys(routes).find(function(k){return normalizeHeliport(k)===nd;});if(!dk)return null;var tk=Object.keys(routes[dk]).find(function(k){return normalizeHeliport(k)===nt;});return tk?routes[dk][tk]:null;}
function updateHeliPrices(){
 if(!ST.pricesData){if(ST.heliDep&&ST.heliDest){setTimeout(updateHeliPrices,200);}return;}
 if(!ST.heliDep||!ST.heliDest)return;
 var routes=(ST.pricesData.routes||{});
 var route=findRoute(routes,ST.heliDep,ST.heliDest);
 HELICOPTERS.forEach(function(h){
 var el=gi('hprice-'+h.id);if(!el)return;
 el.style.display='';
 if(route){var raw=(route.prices||{})[h.name];if(raw){var pre=ST.pricesData.price_prefix?ST.pricesData.price_prefix+' ':'';var cur=ST.pricesData.currency?' '+ST.pricesData.currency:'€';el.textContent=pre+Number(raw).toLocaleString('fr-FR')+cur;el.className='mb-heli-price';}else{el.textContent='Price on request';el.className='mb-heli-price rq';}}
 else{el.textContent='Price on request';el.className='mb-heli-price rq';}
 });
}
window.initAutocomplete = initAutocomplete;
function initAutocomplete(){
 if(typeof google==='undefined'||!google.maps||!google.maps.places){setTimeout(initAutocomplete,300);return;}
 var bounds=new google.maps.LatLngBounds(
  new google.maps.LatLng(43.0,5.5),
  new google.maps.LatLng(44.5,7.8)
 );
 var opts={types:['establishment','geocode'],bounds:bounds,strictBounds:false,componentRestrictions:{country:['fr','mc','it','ch','es']}};
 ['ow-from','ow-to','bth-pickup','cr-pickup','bill-addr'].forEach(function(id){
 var inp=gi(id);if(!inp||inp._ac)return;
 var ac=new google.maps.places.Autocomplete(inp,opts);
 inp.addEventListener('keydown',function(e){if(e.key==='Enter')e.preventDefault();});
 ac.addListener('place_changed',function(){
 var pl=ac.getPlace();
 var v='';if(pl){var _pn=pl.name||'';var _pa=pl.formatted_address||'';v=(_pn&&_pa&&_pa.indexOf(_pn)===-1)?_pn+', '+_pa:(_pa||_pn);}
 if(v)inp.value=v;
 setTimeout(function(){inp.blur();},10);
 });
 inp._ac=true;
 });
}
function validateStep2(){
 for(var i=0;i<ST.svcs.length;i++){
 var svc=ST.svcs[i];
 if(svc==='chauffeur'){
 if(!ST.sub){showErr('Chauffeur: please select One Way or By the Hour.');return false;}
 if(ST.sub==='one-way'){
 if(!val('ow-from')){showErr('Chauffeur: please enter a pickup location.');return false;}
 if(!val('ow-to')){showErr('Chauffeur: please enter a destination.');return false;}
 if(!val('ow-date')){showErr('Chauffeur: please select a date.');return false;}
 if(!val('ow-time')){showErr('Chauffeur: please select a time.');return false;}
 var owAdults=parseInt((gi('ow-adults-v')||{textContent:'0'}).textContent)||0;
 if(owAdults<1){showErr('Chauffeur: please add at least 1 adult passenger.');return false;}
 } else {
 if(!val('bth-pickup')){showErr('Chauffeur: please enter a pickup location.');return false;}
 if(!val('bth-hours')){showErr('Chauffeur: please select a duration.');return false;}
 if(!val('bth-date')){showErr('Chauffeur: please select a date.');return false;}
 if(!val('bth-time')){showErr('Chauffeur: please select a time.');return false;}
 var bthAdults=parseInt((gi('bth-adults-v')||{textContent:'0'}).textContent)||0;
 if(bthAdults<1){showErr('Chauffeur: please add at least 1 adult passenger.');return false;}
 }
 }
 if(svc==='helicopter'){
 if(!ST.heliDep){showErr('Helicopter: please select a departure.');return false;}
 if(!ST.heliDest){showErr('Helicopter: please select a destination.');return false;}
 if(!val('h-date1')){showErr('Helicopter: please select a date.');return false;}
 if(!ST.heliT1){showErr('Helicopter: please select a time.');return false;}
 }
 if(svc==='car-rental'){
 if(!val('cr-type')){showErr('Car Rental: please select a vehicle type.');return false;}
 if(!val('cr-brand')){showErr('Car Rental: please select a brand.');return false;}
 if(!val('cr-start')){showErr('Car Rental: please select a start date.');return false;}
 if(!val('cr-end')){showErr('Car Rental: please select an end date.');return false;}
 if(!val('cr-pickup')){showErr('Car Rental: please enter a pickup location.');return false;}
 if(!val('cr-age')){showErr('Car Rental: please select driver age.');return false;}
 if(!val('cr-licence')){showErr('Car Rental: please enter licence country.');return false;}
 }
 if(svc==='table'){
 if(!val('tb-city-1')){showErr('Table: please select a city.');return false;}
 if(!val('tb-date-1')){showErr('Table: please select a date.');return false;}
 if(!document.getElementById('tb-time-1')||!document.getElementById('tb-time-1').value){showErr('Table: please select a time.');return false;}
 if(!val('tb-covers-1')){showErr('Table: please select number of guests.');return false;}
 }
 }
 return true;
}
function validateStep3(){
 var isOther=gi('other-toggle')&&gi('other-toggle').checked;
 if(isOther){
 if(!val('pax-last')){showErr('Please enter the passenger last name.');return false;}
 if(!val('pax-first')){showErr('Please enter the passenger first name.');return false;}
 var paxPhoneVal=val('pax-phone');
 var paxPhoneErr=gi('pax-phone-err');
 var paxPhoneWrap=gi('pax-phone-wrap');
 var paxPlaceholderDigits=(paxPhoneState.ph||'').replace(/\D/g,'');
 var paxExpected=paxPlaceholderDigits.length||6;
 var paxDigits=paxPhoneVal.replace(/\D/g,'').length;
 var paxStartsZero=paxPlaceholderDigits.charAt(0)==='0';
 var paxMin=paxStartsZero?paxExpected-1:paxExpected;
 var paxOk=paxDigits>=Math.max(6,paxMin)&&paxDigits<=paxExpected+1;
 if(!paxPhoneVal||!paxOk){
 var paxHint=paxPhoneState.ph?'Expected format: '+paxPhoneState.ph+' ('+paxExpected+' digits)':'Digits only, min. 6 digits.';
 if(paxPhoneErr)paxPhoneErr.innerHTML='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Invalid number. '+paxHint;
 if(paxPhoneWrap)paxPhoneWrap.style.borderColor='#c0392b';
 gi('pax-phone').focus();return false;
 }
 if(paxPhoneErr)paxPhoneErr.innerHTML='';if(paxPhoneWrap)paxPhoneWrap.style.borderColor='';
 }
 if(!val('ct-last')){showErr('Please enter your last name.');return false;}
 if(!val('ct-first')){showErr('Please enter your first name.');return false;}
 if(!val('ct-email')||!isEmail(val('ct-email'))){showErr('Please enter a valid email.');return false;}
 var phoneVal=val('ct-phone');
 var phoneErr=gi('phone-err');
 var phoneWrap=gi('ct-phone')?gi('ct-phone').closest('.mb-phone'):null;
 var phonePlaceholder=ST.phone.ph||'';
 var digitsEntered=phoneVal.replace(/\D/g,'');
 var placeholderDigits=phonePlaceholder.replace(/\D/g,'');
 var expectedMin=placeholderDigits.length||6;
 var placeholderStartsZero=placeholderDigits.charAt(0)==='0';
 var minAccept=placeholderStartsZero?expectedMin-1:expectedMin;
 var maxAccept=expectedMin+1; 
 var ok=digitsEntered.length>=Math.max(6,minAccept)&&digitsEntered.length<=maxAccept;
 if(!phoneVal||!ok){
 var hint=phonePlaceholder?'Expected format: '+phonePlaceholder+' ('+expectedMin+' digits)':'Digits only, min. 6 digits.';
 if(phoneErr){
 phoneErr.innerHTML='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Invalid number. '+hint;
 }
 if(phoneWrap)phoneWrap.style.borderColor='#c0392b';
 gi('ct-phone').focus();
 return false;
 }
 if(phoneErr)phoneErr.innerHTML='';
 if(phoneWrap)phoneWrap.style.borderColor='';
 return true;
}
function fmtDate(d){if(!d)return '';var p=d.split('-');return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:d;}
function svgClock(){return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';}
function svgCal(){return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';}
function svgEdit(){return '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>';}
function drow(k,v){return v?'<div class="mb-recap-detail-row"><span class="mb-recap-dk">'+k+'</span><span class="mb-recap-dv">'+v+'</span></div>':'';}
 function ditem(k,v,iconSvg){
 if(!v)return '';
 var ic=iconSvg?'<div style="width:22px;height:22px;background:rgba(184,160,106,.12);border-radius:5px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">'+iconSvg+'</div>':'';
 return '<div style="display:flex;align-items:center;gap:8px;">'
 +ic
 +'<div style="min-width:0;">'
 +'<div style="font-size:10px;color:#9E9890;letter-spacing:.1em;text-transform:uppercase;font-weight:700;">'+k+'</div>'
 +'<div style="font-size:14px;font-weight:500;color:#0D0D0F;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+v+'</div>'
 +'</div>'
 +'</div>';
 }
function dblock(lbl,v,ic,dk){if(!v||v==='—')return '';var bg=dk?'background:#002f1c;':'background:rgba(184,160,106,.1);';var lc=dk?'color:rgba(184,160,106,.6);':'color:var(--text3,#9e9e9e);';var vc=dk?'color:#B8A06A;':'color:var(--text,#1a1c1e);';var svg=ic?'<div style="margin-bottom:4px;">'+ic.replace(/stroke="currentColor"/g,'stroke="#B8A06A"')+'</div>':'';return '<div style="'+bg+'border-radius:8px;padding:12px;display:flex;flex-direction:column;gap:4px;">'+svg+'<div style="font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;'+lc+'">'+lbl+'</div><div style="font-size:13px;font-weight:500;'+vc+'">'+v+'</div></div>';}
function drow(v,ic){if(!v||v.trim()===''||v==='undefined')return '';var svg=ic?'<span style="flex-shrink:0;color:var(--text3);">'+ic+'</span>':'';return '<div style="display:flex;align-items:center;gap:6px;font-size:13px;font-weight:500;color:var(--text,#1a1c1e);">'+svg+' '+v+'</div>';}
function dsec(t,g){return '<div style="font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;'+(g?'color:#B8A06A;':'color:var(--text3,#9e9e9e);')+'margin-bottom:8px;">'+t+'</div>';}

function buildRecap(){
 var box=gi('mb-recap');if(!box)return;
 var isMob=window.innerWidth<768||screen.width<768||(window.matchMedia&&window.matchMedia("(max-width:767px)").matches);
 var lbls={chauffeur:'Chauffeur Service',helicopter:'Helicopter Transfer','car-rental':'Luxury Car Rental',table:'Table Reservation'};

 // ── Helpers mobile ──────────────────────────────────────────
 function mrow(lbl,v,odd){
  if(!v||v==='—')return '';
  return '<div style="display:flex;align-items:center;gap:12px;padding:10px 16px;'+(odd?'background:rgba(184,160,106,.15);':'')+'border-bottom:1px solid rgba(184,160,106,.07);">'
   +'<span style="font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#9E9890;min-width:90px;flex-shrink:0;">'+lbl+'</span>'
   +'<span style="font-size:13px;font-weight:600;color:#0D0D0F;">'+v+'</span>'
   +'</div>';
 }
 function msec(title,gold,items){
  var rows=items.filter(function(i){return i.v;}).map(function(it){
   return '<div style="display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid rgba(184,160,106,.08);">'
    +'<span style="flex-shrink:0;color:#9E9890;">'+it.ic+'</span>'
    +'<span style="font-size:13px;font-weight:'+(it.bold?'600':'500')+';color:#0D0D0F;">'+it.v+'</span>'
    +'</div>';
  }).join('');
  if(!rows)return '';
  return '<div style="border-top:1.5px solid rgba(184,160,106,.25);padding:12px 16px 14px;'
   +(gold?'background:rgba(184,160,106,.06);':'background:#fff;')+'border-bottom:none;">'
   +'<div style="font-size:9px;font-weight:700;letter-spacing:.15em;text-transform:uppercase;'
   +(gold?'color:#B8A06A;':'color:#9E9890;')+'margin-bottom:10px;">'+title+'</div>'
   +rows
   +'</div>';
 }
 // ── SVG icons inline ──────────────────────────────────────
 var icUser='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
 var icMail='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>';
 var icPhone='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>';
 var icBiz='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>';
 var icVat='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>';
 var icPin='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>';

 // ── Sections contact communes ──────────────────────────────
 function buildContactSections(isOther,bkFirst,bkLast,bkEmail,bkPhone,bkPhoneCode,paxFirst,paxLast,paxPhone,paxPhoneCode,isBill){
  var h='';
  if(isOther&&(paxFirst||paxLast)){
   h+=msec('Lead passenger',true,[
    {ic:icUser,v:(paxFirst+' '+paxLast).trim(),bold:true},
    {ic:icPhone,v:paxPhone?(paxPhoneCode+' '+paxPhone):''}
   ]);
  }
  h+=msec('Booker',false,[
   {ic:icUser,v:(bkFirst+' '+bkLast).trim(),bold:true},
   {ic:icMail,v:bkEmail},
   {ic:icPhone,v:bkPhone?(bkPhoneCode+' '+bkPhone):''}
  ]);
  if(isBill){
   var billItems=[];
   if(val('bill-company'))billItems.push({ic:icBiz,v:val('bill-company'),bold:true});
   if(val('bill-vat'))billItems.push({ic:icVat,v:val('bill-vat')});
   var ba=[val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', ');
   if(ba)billItems.push({ic:icPin,v:ba});
   if(billItems.length)h+=msec('Billing',true,billItems);
  }
  return h;
 }

 var html='<div class="mb-recap-hdr">';
 html+='<span class="mb-recap-hdr-title">Your Booking Summary</span>';
 html+='<button type="button" class="mb-recap-hdr-edit" id="recap-edit-btn">'+svgEdit()+' Modify</button>';
 html+='</div>';
 html+='<div class="mb-recap-body">';

 ST.svcs.forEach(function(svc,idx){
  if(idx>0)html+='<hr class="mb-recap-sep">';

  // ── Variables contact communes ──────────────────────────
  var _isOther=gi('other-toggle')&&gi('other-toggle').checked;
  var _isBill=gi('bill-toggle')&&gi('bill-toggle').checked&&(val('bill-company')||val('bill-addr'));
  var _bkFirst=val('ct-first')||'';
  var _bkLast=val('ct-last')||'';
  var _bkEmail=val('ct-email')||'';
  var _bkPhone=val('ct-phone')||'';
  var _bkCode=ST.phone&&ST.phone.code?ST.phone.code:'';
  var _paxFirst=val('pax-first')||'';
  var _paxLast=val('pax-last')||'';
  var _paxPhone=val('pax-phone')||'';
  var _paxCode=paxPhoneState&&paxPhoneState.code?paxPhoneState.code:'';

  if(svc==='chauffeur'){
   var isOW=ST.sub==='one-way';
   var from=isOW?val('ow-from'):val('bth-pickup');
   var to=isOW?val('ow-to'):'';
   var date=isOW?val('ow-date'):val('bth-date');
   var time=isOW?val('ow-time'):val('bth-time');
   var veh=VEHICLES.find(function(x){return x.id===ST.selVeh;});
   var prefix=isOW?'OW':'BTH';
   var stops=[];
   var n=ST['stopCnt'+prefix]||0;
   for(var si=1;si<=n;si++){var sv=val('stop-'+prefix+'-'+si);if(sv)stops.push(sv);}
   var pref2=isOW?'ow':'bth';
   var ad=parseInt((gi(pref2+'-adults-v')||{textContent:'1'}).textContent)||1;
   var ch=parseInt((gi(pref2+'-children-v')||{textContent:'0'}).textContent)||0;
   var ba2=parseInt((gi(pref2+'-babies-v')||{textContent:'0'}).textContent)||0;
   var pe=parseInt((gi(pref2+'-pets-v')||{textContent:'0'}).textContent)||0;
   var paxParts=[];
   if(ad)paxParts.push(ad+' adult'+(ad>1?'s':''));
   if(ch)paxParts.push(ch+' child'+(ch>1?'ren':''));
   if(ba2)paxParts.push(ba2+' baby'+(ba2>1?'ies':''));
   if(pe)paxParts.push(pe+' pet'+(pe>1?'s':''));
   var paxStr=paxParts.join(', ')||'1 adult';
   var cab=parseInt((gi(pref2+'-cabin-v')||{textContent:'0'}).textContent)||0;
   var hold=parseInt((gi(pref2+'-hold-v')||{textContent:'0'}).textContent)||0;
   var spec=parseInt((gi(pref2+'-special-v')||{textContent:'0'}).textContent)||0;
   var lugParts=[];
   if(cab)lugParts.push(cab+' cabin');if(hold)lugParts.push(hold+' hold');if(spec)lugParts.push(spec+' special');
   var lugStr=lugParts.join(', ')||'—';
   var _cSvc=isOW?'One Way Transfer':'By the Hour';
   var _cDur=!isOW&&val('bth-hours')?val('bth-hours')+'H':null;
   var inf=parseInt((gi(pref2+'-infant-v')||{textContent:'0'}).textContent)||0;
   var chs=parseInt((gi(pref2+'-child-s-v')||{textContent:'0'}).textContent)||0;
   var boo=parseInt((gi(pref2+'-booster-v')||{textContent:'0'}).textContent)||0;
   var seatParts=[];
   if(inf)seatParts.push(inf+' infant');if(chs)seatParts.push(chs+' child');if(boo)seatParts.push(boo+' booster');

   html+='<div class="mb-recap-sec">'+lbls[svc]+'</div>';
   // Route — mobile vs desktop
   if(isMob){
    html+='<div style="padding:14px 16px;border-bottom:1px solid rgba(184,160,106,.12);">';
    // Track ligne
    html+='<div style="display:flex;align-items:center;margin-bottom:14px;position:relative;">';
    html+='<div style="width:10px;height:10px;border-radius:50%;border:2px solid #B8A06A;background:#fff;flex-shrink:0;z-index:1;"></div>';
    html+='<div style="flex:1;height:1px;background:repeating-linear-gradient(to right,#B8A06A 0,#B8A06A 5px,transparent 5px,transparent 10px);position:relative;margin:0 2px;">';
    if(isOW&&from&&to)html+='<div id="recap-route-duration" style="position:absolute;left:50%;transform:translateX(-50%);top:-11px;background:#0D0D0F;color:#fff;font-size:11px;font-weight:600;padding:3px 10px;border-radius:999px;white-space:nowrap;">—</div>';
    html+='</div>';
    if(isOW)html+='<div style="width:10px;height:10px;border-radius:50%;border:2px solid #B8A06A;background:#B8A06A;flex-shrink:0;z-index:1;"></div>';
    html+='</div>';
    // Points A/B
    html+='<div style="display:flex;justify-content:space-between;align-items:flex-start;">';
    html+='<div>';
    html+='<div style="font-size:14px;font-weight:700;color:#0D0D0F;">'+(from||'—')+'</div>';
    html+='<div style="display:flex;align-items:center;gap:6px;margin-top:4px;">';
    html+='<span style="font-size:11px;color:#5A5751;display:flex;align-items:center;gap:4px;">'+svgCal()+' '+fmtDate(date)+'</span>';
    html+='<span style="font-size:11px;color:#5A5751;">· '+(time||'—')+'</span>';
    html+='</div></div>';
    if(isOW&&to){
     html+='<div style="text-align:right;">';
     html+='<div style="font-size:14px;font-weight:700;color:#0D0D0F;">'+to+'</div>';
     html+='<div style="font-size:11px;color:#5A5751;font-style:italic;margin-top:4px;" id="recap-eta"><span id="recap-eta-val"></span></div>';
     html+='</div>';
    }
    html+='</div>';
    html+='</div>';
   } else {
    html+='<div class="mb-recap-route">';
    html+='<div class="mb-recap-route-track">';
    html+='<div class="mb-recap-route-dot"></div>';
    html+='<div class="mb-recap-route-line">';
    if(isOW&&from&&to)html+='<div class="mb-recap-route-badge" id="recap-route-duration">—</div>';
    html+='</div>';
    if(isOW)html+='<div class="mb-recap-route-dot end"></div>';
    html+='</div>';
    html+='<div class="mb-recap-route-pts">';
    html+='<div class="mb-recap-route-pt"><div class="mb-recap-city">'+(from||'—')+'</div>';
    html+='<div class="mb-recap-datetime"><div class="mb-recap-dt-date">'+svgCal()+' '+fmtDate(date)+'</div><div class="mb-recap-dt-sep"></div><div class="mb-recap-dt-time">'+svgClock()+' '+(time||'—')+'</div></div></div>';
    if(isOW){
     html+='<div class="mb-recap-route-pt right"><div class="mb-recap-city">'+(to||'—')+'</div>';
     html+='<div class="mb-recap-eta" id="recap-eta">'+svgClock()+' <span id="recap-eta-val">—</span></div></div>';
    }
    html+='</div></div>';
   }
   // Map
   var mapH=isMob?160:240;
   html+='<div style="position:relative;height:'+mapH+'px;border-bottom:1px solid rgba(184,160,106,.12);">';
   html+='<div id="mb-route-map" style="width:100%;height:100%;"></div>';
   html+='</div>';
   // Stops
   if(stops.length){
    html+='<div style="padding:8px '+(isMob?'16':'28')+'px;background:rgba(184,160,106,.03);border-bottom:1px solid rgba(184,160,106,.08);display:flex;flex-wrap:wrap;gap:6px;align-items:center;">';
    html+='<span style="display:inline-flex;align-items:center;gap:4px;font-size:10px;color:#B8A06A;letter-spacing:.12em;text-transform:uppercase;font-weight:700;margin-right:4px;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>Stops</span>';
    stops.forEach(function(s){html+='<span style="font-size:12.5px;background:rgba(184,160,106,.1);border:1px solid rgba(184,160,106,.2);border-radius:4px;padding:2px 8px;color:#0D0D0F;">'+s+'</span>';});
    html+='</div>';
   }
   if(isOW&&ST.hasRetOW){
    var retDate=val('ow-ret-date'),retTime=val('ow-ret-time');
    html+='<div style="padding:8px '+(isMob?'16':'28')+'px;background:rgba(184,160,106,.10);border-bottom:1px solid rgba(184,160,106,.08);display:flex;align-items:center;gap:10px;">';
    html+='<span style="color:#B8A06A;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg></span>';
    html+='<span style="font-size:10px;color:#B8A06A;letter-spacing:.12em;text-transform:uppercase;font-weight:700;">Return</span>';
    html+='<span style="font-size:13px;font-weight:500;color:#0D0D0F;">'+fmtDate(retDate)+(retTime?' · '+retTime:'')+'</span>';
    html+='</div>';
   }
   // Details
   if(isMob){
    var rows='';
    rows+=mrow('Service',_cSvc,true);
    rows+=mrow('Vehicle',veh?veh.name:'—',false);
    rows+=mrow('Date',fmtDate(date),true);
    rows+=mrow(isOW?'Pickup time':'Start time',time||'—',false);
    if(_cDur)rows+=mrow('Duration',_cDur,true);
    rows+=mrow('Passengers',paxStr,_cDur?false:true);
    rows+=mrow('Luggage',lugStr,_cDur?true:false);
    if(seatParts.length)rows+=mrow('Child seats',seatParts.join(', '),true);
    html+='<div style="border-bottom:1px solid rgba(184,160,106,.12);">'+rows+'</div>';
    html+=buildContactSections(_isOther,_bkFirst,_bkLast,_bkEmail,_bkPhone,_bkCode,_paxFirst,_paxLast,_paxPhone,_paxCode,_isBill);
   } else {
    html+='<div style="padding:16px 20px;">';
    html+='<div style="display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:8px;">';
    html+=dblock('Service',_cSvc,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',false);
    html+=dblock('Vehicle',veh?veh.name:'—','<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',false);
    html+=dblock('Date',fmtDate(date),'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',false);
    html+=dblock(isOW?'Pickup time':'Start time',time||'—','<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',false);
    if(_cDur)html+=dblock('Duration',_cDur,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',false);
    else html+=dblock('Passengers',paxStr,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>',false);
    html+=dblock(_cDur?'Passengers':'Luggage',_cDur?paxStr:(lugStr||'—'),'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>',false);
    html+='</div></div>';
    if(_isOther&&val('pax-first')){
     html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.2);">';
     html+=dsec('Lead passenger',true);
     html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
     var _lpn=(_paxFirst+' '+_paxLast).trim();
     if(_lpn)html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid rgba(184,160,106,.3);">'+drow(_lpn,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>';
     if(_paxPhone)html+='<div>'+drow(_paxCode+' '+_paxPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>';
     html+='</div></div>';
    }
    html+='<div style="padding:12px 20px;background:var(--white,#fff);border-top:0.5px solid rgba(184,160,106,.10);">';
    html+=dsec('Booker',false);
    html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
    var _bkn=(_bkFirst+' '+_bkLast).trim();
    html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bkn,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>';
    if(_bkEmail)html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bkEmail,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>')+'</div>';
    html+='<div>'+drow(_bkCode+' '+_bkPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>';
    html+='</div></div>';
    if(_isBill){
     html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.15);">';
     html+=dsec('Billing',false);
     html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
     if(val('bill-company'))html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-company'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>')+'</div>';
     if(val('bill-vat'))html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-vat'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>')+'</div>';
     var _ba=[val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', ');
     if(_ba)html+='<div>'+drow(_ba,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>')+'</div>';
     html+='</div></div>';
    }
   }
  }
  else if(svc==='helicopter'){
   var hel=HELICOPTERS.find(function(x){return x.id===ST.selHeli;});
   var _hRoute=ST.pricesData?findRoute(ST.pricesData.routes||{},ST.heliDep,ST.heliDest):null;
   var _hP=_hRoute&&hel?(_hRoute.prices||{})[hel.name]:null;
   var _hD=_hRoute?_hRoute.duration_minutes:null;
   var _hPs=_hP?Number(_hP).toLocaleString('fr-FR')+' '+(ST.pricesData.currency||'€'):null;
   var _hDs=_hD?(_hD<60?(_hD+' min'):(Math.floor(_hD/60)+'h'+(_hD%60?(''+_hD%60).padStart(2,'0'):''))):null;
   var _hPax=(function(){var a=parseInt((gi('h-adults-v')||{textContent:'1'}).textContent)||1;var c=parseInt((gi('h-children-v')||{textContent:'0'}).textContent)||0;var b=parseInt((gi('h-babies-v')||{textContent:'0'}).textContent)||0;var p=[];if(a)p.push(a+' adult'+(a>1?'s':''));if(c)p.push(c+' child'+(c>1?'ren':''));if(b)p.push(b+' baby'+(b>1?'ies':''));return p.join(', ')||'1 adult';})();
   var _hLug=(function(){var c=parseInt((gi('h-cabin-v')||{textContent:'0'}).textContent)||0;var h=parseInt((gi('h-hold-v')||{textContent:'0'}).textContent)||0;var s=parseInt((gi('h-special-v')||{textContent:'0'}).textContent)||0;var p=[];if(c)p.push(c+' cabin');if(h)p.push(h+' suitcase'+(h>1?'s':''));if(s)p.push(s+' special');return p.join(', ')||null;})();
   var durText=ST.heliDurText||'...';

   html+='<div class="mb-recap-sec">'+lbls[svc]+'</div>';
   // Route héli — mobile vs desktop
   if(isMob){
    html+='<div style="padding:14px 16px;border-bottom:1px solid rgba(184,160,106,.12);">';
    html+='<div style="display:flex;align-items:center;margin-bottom:14px;position:relative;">';
    html+='<div style="width:10px;height:10px;border-radius:50%;border:2px solid #B8A06A;background:#fff;flex-shrink:0;z-index:1;"></div>';
    html+='<div style="flex:1;height:1px;background:repeating-linear-gradient(to right,#B8A06A 0,#B8A06A 5px,transparent 5px,transparent 10px);position:relative;margin:0 2px;">';
    html+='<div style="position:absolute;left:50%;transform:translateX(-50%);top:-11px;background:#0D0D0F;color:#fff;font-size:11px;font-weight:600;padding:3px 10px;border-radius:999px;white-space:nowrap;">'+durText+'</div>';
    html+='</div>';
    html+='<div style="width:10px;height:10px;border-radius:50%;border:2px solid #B8A06A;background:#B8A06A;flex-shrink:0;z-index:1;"></div>';
    html+='</div>';
    html+='<div style="display:flex;justify-content:space-between;align-items:flex-start;">';
    html+='<div>';
    html+='<div style="font-size:14px;font-weight:700;color:#0D0D0F;">'+(ST.heliDep||'—')+'</div>';
    html+='<div style="display:flex;align-items:center;gap:6px;margin-top:4px;">';
    html+='<span style="font-size:11px;color:#5A5751;display:flex;align-items:center;gap:4px;">'+svgCal()+' '+fmtDate(val('h-date1'))+'</span>';
    html+='<span style="font-size:11px;color:#5A5751;">· '+(ST.heliT1||'—')+'</span>';
    html+='</div></div>';
    html+='<div style="text-align:right;">';
    html+='<div style="font-size:14px;font-weight:700;color:#0D0D0F;">'+(ST.heliDest||'—')+'</div>';
    html+='</div>';
    html+='</div></div>';
   } else {
    html+='<div class="mb-recap-route">';
    html+='<div class="mb-recap-route-track">';
    html+='<div class="mb-recap-route-dot"></div>';
    html+='<div class="mb-recap-route-line"><div class="mb-recap-route-badge">'+durText+'</div></div>';
    html+='<div class="mb-recap-route-dot end"></div>';
    html+='</div>';
    html+='<div class="mb-recap-route-pts">';
    html+='<div class="mb-recap-route-pt"><div class="mb-recap-city">'+(ST.heliDep||'—')+'</div>';
    html+='<div class="mb-recap-datetime"><div class="mb-recap-dt-date">'+svgCal()+' '+fmtDate(val('h-date1'))+'</div><div class="mb-recap-dt-sep"></div><div class="mb-recap-dt-time">'+svgClock()+' '+(ST.heliT1||'—')+'</div></div></div>';
    html+='<div class="mb-recap-route-pt right"><div class="mb-recap-city">'+(ST.heliDest||'—')+'</div></div>';
    html+='</div></div>';
   }
   // Map héli
   var heliMapH=isMob?160:280;
   html+='<div style="position:relative;height:'+heliMapH+'px;border-top:1px solid rgba(184,160,106,.12);border-bottom:1px solid rgba(184,160,106,.12);overflow:hidden;">';
   html+='<div id="mb-route-map" style="width:100%;height:100%;border-radius:0 !important;"></div>';
   html+='</div>';
   // Details héli
   if(isMob){
    var hrows='';
    hrows+=mrow('Aircraft',hel?hel.name:'—',true);
    hrows+=mrow('Date',fmtDate(val('h-date1')),false);
    hrows+=mrow('Departure',ST.heliT1||'—',true);
    hrows+=mrow('Passengers',_hPax,false);
    if(_hLug)hrows+=mrow('Luggage',_hLug,true);
    if(_hPs)hrows+='<div style="display:flex;align-items:center;gap:12px;padding:10px 16px;background:#002f1c;">'
     +'<span style="font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:rgba(184,160,106,.7);min-width:90px;flex-shrink:0;">Price</span>'
     +'<span style="font-size:13px;font-weight:700;color:#B8A06A;">'+_hPs+'</span>'
     +'</div>';
    else if(_hDs)hrows+=mrow('Flight time',_hDs,false);
    html+='<div style="border-bottom:1px solid rgba(184,160,106,.12);">'+hrows+'</div>';
    html+=buildContactSections(_isOther,_bkFirst,_bkLast,_bkEmail,_bkPhone,_bkCode,_paxFirst,_paxLast,_paxPhone,_paxCode,_isBill);
   } else {
    html+='<div style="padding:16px 20px;">';
    html+='<div style="display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:8px;">';
    html+=dblock('Aircraft',hel?hel.name:'—','<svg width="16" height="16" viewBox="0 0 80 80" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M55 36C55 36 50 28 38 27C26 26 16 33 16 33"/><circle cx="38" cy="34" r="4" fill="currentColor"/><path d="M55 36L61 33.5L59.5 39L65 41"/></svg>',false);
    html+=dblock('Date',fmtDate(val('h-date1')),'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',false);
    html+=dblock('Departure',ST.heliT1||'—','<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',false);
    html+=dblock('Passengers',_hPax,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>',false);
    html+=dblock('Luggage',_hLug||'—','<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>',false);
    if(_hPs)html+=dblock('Price',_hPs,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>',true);
    else if(_hDs)html+=dblock('Flight time',_hDs,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',false);
    html+='</div></div>';
    if(_isOther&&val('pax-first')){
     html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.2);">';
     html+=dsec('Lead passenger',true);
     html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
     var _lpnH=(_paxFirst+' '+_paxLast).trim();
     if(_lpnH)html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid rgba(184,160,106,.3);">'+drow(_lpnH,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>';
     if(_paxPhone)html+='<div>'+drow(_paxCode+' '+_paxPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>';
     html+='</div></div>';
    }
    html+='<div style="padding:12px 20px;background:var(--white,#fff);border-top:0.5px solid rgba(184,160,106,.15);">';
    html+=dsec('Booker',false);
    html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
    var _bknH=(_bkFirst+' '+_bkLast).trim();
    html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bknH,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>';
    if(_bkEmail)html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bkEmail,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>')+'</div>';
    html+='<div>'+drow(_bkCode+' '+_bkPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>';
    html+='</div></div>';
    if(_isBill){
     html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.15);">';
     html+=dsec('Billing',false);
     html+='<div style="display:flex;gap:0;flex-wrap:wrap;">';
     if(val('bill-company'))html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-company'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>')+'</div>';
     if(val('bill-vat'))html+='<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-vat'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>')+'</div>';
     var _baH=[val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', ');
     if(_baH)html+='<div>'+drow(_baH,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>')+'</div>';
     html+='</div></div>';
    }
   }
  }
  else if(svc==='car-rental'){
   var _crT=val('cr-type')||'—';var _crB=val('cr-brand')||null;
   var _crS=fmtDate(val('cr-start'))||'—';var _crE=fmtDate(val('cr-end'))||null;
   var _crP=val('cr-pickup')||null;var _crA=val('cr-age')||null;
   if(isMob){
    var crrows='';
    crrows+=mrow('Type',_crT,true);
    if(_crB)crrows+=mrow('Brand',_crB,false);
    crrows+=mrow('From',_crS,true);
    if(_crE)crrows+=mrow('Until',_crE,false);
    if(_crP)crrows+=mrow('Pickup',_crP,true);
    if(_crA)crrows+=mrow('Driver age',_crA,false);
    html+='<div style="border-bottom:1px solid rgba(184,160,106,.12);">'+crrows+'</div>';
    html+=buildContactSections(_isOther,_bkFirst,_bkLast,_bkEmail,_bkPhone,_bkCode,_paxFirst,_paxLast,_paxPhone,_paxCode,_isBill);
   } else {
    html+='<div style="padding:16px 20px;"><div style="display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:8px;">';
    html+=dblock('Vehicle type',_crT,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',false);
    if(_crB)html+=dblock('Brand',_crB,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',false);
    html+=dblock('From',_crS,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',false);
    if(_crE)html+=dblock('Until',_crE,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',false);
    if(_crP)html+=dblock('Pickup',_crP,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>',false);
    if(_crA)html+=dblock('Driver age',_crA,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',false);
    html+='</div></div>';
    // desktop contact car-rental (même pattern que chauffeur desktop)
    if(_isOther&&_paxFirst){html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.2);">'+dsec('Lead passenger',true)+'<div style="display:flex;gap:0;flex-wrap:wrap;"><div style="padding-right:20px;margin-right:20px;border-right:0.5px solid rgba(184,160,106,.3);">'+drow((_paxFirst+' '+_paxLast).trim(),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>'+(_paxPhone?'<div>'+drow(_paxCode+' '+_paxPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>':'')+'</div></div>';}
    html+='<div style="padding:12px 20px;background:var(--white,#fff);border-top:0.5px solid rgba(184,160,106,.15);">'+dsec('Booker',false)+'<div style="display:flex;gap:0;flex-wrap:wrap;"><div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow((_bkFirst+' '+_bkLast).trim(),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>'+(_bkEmail?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bkEmail,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>')+'</div>':'')+'<div>'+drow(_bkCode+' '+_bkPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div></div></div>';
    if(_isBill){html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.15);">'+dsec('Billing',false)+'<div style="display:flex;gap:0;flex-wrap:wrap;">'+(val('bill-company')?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-company'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>')+'</div>':'')+(val('bill-vat')?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-vat'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>')+'</div>':'')+(([val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', '))?'<div>'+drow([val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', '),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>')+'</div>':'')+'</div></div>';}
   }
  }
  else if(svc==='table'){
   var rCards=document.querySelectorAll('.tb-resto-card');
   var rList=[];
   for(var ri2=0;ri2<Math.max(rCards.length,1);ri2++){
    var rn=ri2+1;
    rList.push({n:rn,city:val('tb-city-'+rn)||'',date:fmtDate(val('tb-date-'+rn)),time:(gi('tb-time-'+rn)&&gi('tb-time-'+rn).value)||'',covers:val('tb-covers-'+rn)||'',resto:val('tb-resto-'+rn)||'',occ:val('tb-occ-'+rn)||''});
   }
   if(isMob){
    rList.forEach(function(r){
     if(rList.length>1)html+='<div style="padding:8px 16px 0;font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--gold);">Restaurant '+r.n+'</div>';
     var trrows='';
     if(r.city)trrows+=mrow('City',r.city,true);
     if(r.resto)trrows+=mrow('Restaurant',r.resto,false);
     if(r.date)trrows+=mrow('Date',r.date,true);
     if(r.time)trrows+=mrow('Time',r.time,false);
     if(r.covers)trrows+=mrow('Guests',r.covers,true);
     if(r.occ&&r.occ!=='None')trrows+=mrow('Occasion',r.occ,false);
     html+='<div style="border-bottom:1px solid rgba(184,160,106,.08);">'+trrows+'</div>';
    });
    html+=buildContactSections(_isOther,_bkFirst,_bkLast,_bkEmail,_bkPhone,_bkCode,_paxFirst,_paxLast,_paxPhone,_paxCode,_isBill);
   } else {
    rList.forEach(function(r){
     if(rList.length>1)html+='<div style="padding:8px 20px 0;font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--gold);">Restaurant '+r.n+'</div>';
     html+='<div style="padding:12px 20px;"><div style="display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:8px;">';
     if(r.city)html+=dblock('City',r.city,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>',false);
     if(r.resto)html+=dblock('Restaurant',r.resto,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 002-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 00-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/></svg>',false);
     if(r.date)html+=dblock('Date',r.date,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',false);
     if(r.time)html+=dblock('Time',r.time,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',false);
     if(r.covers)html+=dblock('Guests',r.covers,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>',false);
     if(r.occ&&r.occ!=='None')html+=dblock('Occasion',r.occ,'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',false);
     html+='</div></div>';
     if(rList.length>1&&r.n<rList.length)html+='<hr style="border:none;border-top:0.5px solid rgba(184,160,106,.2);margin:0 20px;">';
    });
    if(_isOther&&_paxFirst){html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.2);">'+dsec('Lead passenger',true)+'<div style="display:flex;gap:0;flex-wrap:wrap;"><div style="padding-right:20px;margin-right:20px;border-right:0.5px solid rgba(184,160,106,.3);">'+drow((_paxFirst+' '+_paxLast).trim(),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>'+(_paxPhone?'<div>'+drow(_paxCode+' '+_paxPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div>':'')+'</div></div>';}
    html+='<div style="padding:12px 20px;background:var(--white,#fff);border-top:0.5px solid rgba(184,160,106,.15);">'+dsec('Booker',false)+'<div style="display:flex;gap:0;flex-wrap:wrap;"><div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow((_bkFirst+' '+_bkLast).trim(),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>')+'</div>'+(_bkEmail?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(_bkEmail,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>')+'</div>':'')+'<div>'+drow(_bkCode+' '+_bkPhone,'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>')+'</div></div></div>';
    if(_isBill){html+='<div style="padding:12px 20px;background:rgba(184,160,106,.1);border-top:0.5px solid rgba(184,160,106,.15);">'+dsec('Billing',false)+'<div style="display:flex;gap:0;flex-wrap:wrap;">'+(val('bill-company')?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-company'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>')+'</div>':'')+(val('bill-vat')?'<div style="padding-right:20px;margin-right:20px;border-right:0.5px solid var(--field-bd,#e0d9cc);">'+drow(val('bill-vat'),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>')+'</div>':'')+(([val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', '))?'<div>'+drow([val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', '),'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z"/><circle cx="12" cy="9" r="2.5"/></svg>')+'</div>':'')+'</div></div>';}
   }
  }
 });

 html+='</div>';
 box.innerHTML=html;
 var editBtn=gi('recap-edit-btn');
 if(editBtn)editBtn.addEventListener('click',function(){gi('btn4-prev').click();});
 buildRouteMap();
}


function buildRouteMap(){
 var mapDiv=gi('mb-route-map');
 var badge=gi('mb-map-badge');
 var durationBadge=gi('recap-route-duration');
 if(!mapDiv)return;
 var isHeli=ST.svcs.indexOf('helicopter')>-1&&ST.svcs.indexOf('chauffeur')<0;
 var origin='',destination='';
 if(ST.svcs.indexOf('chauffeur')>-1){
 if(ST.sub==='one-way'){origin=val('ow-from');destination=val('ow-to');}
 else{origin=val('bth-pickup');}
 } else if(isHeli){
 origin=ST.heliDep;destination=ST.heliDest;
 }
 if(!origin)return;
 if(isHeli){
 var mapEl=gi('mb-route-map');
 if(mapEl){
 var recapMap=mapEl.closest('.mb-recap-map-wrap')||mapEl.parentElement;
 if(recapMap){recapMap.style.gridTemplateColumns='1fr';recapMap.style.display='block';}
 mapEl.style.height='280px';
 mapEl.style.borderRadius='var(--rsm)';
 }
 }
 function addMarker(map,pos,label,dark){
 new google.maps.Marker({
 position:pos,map:map,
 label:{text:label,color:dark?'#fff':'#0D0D0F',fontWeight:'700',fontSize:'11px'},
 icon:{path:google.maps.SymbolPath.CIRCLE,scale:11,
 fillColor:dark?'#0D0D0F':'#B8A06A',fillOpacity:1,
 strokeColor:dark?'#B8A06A':'#fff',strokeWeight:2}
 });
 }
 var mapStyles=[
 {featureType:'poi',elementType:'labels',stylers:[{visibility:'off'}]},
 {featureType:'transit',elementType:'labels',stylers:[{visibility:'off'}]},
 {featureType:'road.highway',elementType:'geometry',stylers:[{color:'#e8dcc8'}]},
 {featureType:'water',elementType:'geometry',stylers:[{color:'#c8dce8'}]},
 {featureType:'landscape',elementType:'geometry',stylers:[{color:'#f5f2ec'}]}
 ];
 function initMap(){
 var map=new google.maps.Map(mapDiv,{
 zoom:8,center:{lat:43.7,lng:7.2},
 mapTypeId:'roadmap',zoomControl:true,
 streetViewControl:false,mapTypeControl:false,fullscreenControl:true,
 styles:mapStyles
 });
 if(!destination){
 new google.maps.Geocoder().geocode({address:origin},function(r,s){
 if(s==='OK'){map.setCenter(r[0].geometry.location);map.setZoom(12);addMarker(map,r[0].geometry.location,'A',true);}
 });
 return;
 }
 var gc=new google.maps.Geocoder();
 gc.geocode({address:origin},function(r1,s1){
 gc.geocode({address:destination},function(r2,s2){
 var p1=s1==='OK'?r1[0].geometry.location:null;
 var p2=s2==='OK'?r2[0].geometry.location:null;
 if(!p1||!p2)return;
 addMarker(map,p1,'A',true);
 addMarker(map,p2,'B',false);
 var bounds=new google.maps.LatLngBounds();
 bounds.extend(p1);bounds.extend(p2);
 map.fitBounds(bounds,{top:40,right:60,bottom:60,left:60});
 if(isHeli){
 new google.maps.Polyline({
 path:[p1,p2],geodesic:true,
 strokeColor:'#B8A06A',strokeOpacity:0,strokeWeight:0,
 icons:[{icon:{path:'M 0,-1 0,1',strokeOpacity:1,strokeColor:'#B8A06A',scale:4},offset:'0',repeat:'16px'}],
 map:map
 });
 var R=6371;
 var lat1=p1.lat()*Math.PI/180,lat2=p2.lat()*Math.PI/180;
 var dLat=(p2.lat()-p1.lat())*Math.PI/180;
 var dLng=(p2.lng()-p1.lng())*Math.PI/180;
 var a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(lat1)*Math.cos(lat2)*Math.sin(dLng/2)*Math.sin(dLng/2);
 var distKm=Math.round(R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)));
 var speedKmh=280; 
 var durMins=Math.round(distKm/speedKmh*60);
 var durText=(durMins>=60?Math.floor(durMins/60)+'h ':'')+(durMins%60)+'min';
 ST.heliDistKm=distKm; ST.heliDurText='~'+durText;
 var routeBadge=document.querySelector('.mb-recap-route-badge');
 if(routeBadge)routeBadge.textContent='~'+durText;
 if(durationBadge)durationBadge.textContent=durText;
 if(badge){badge.innerHTML='~'+distKm+' km (direct)&nbsp;&nbsp;<span style="opacity:.35">|</span>&nbsp;&nbsp;~'+durText;badge.style.display='block';}
 } else {
 var waypoints=[];
 var stopsPrefix=ST.sub==='one-way'?'OW':'BTH';
 var nStops=ST['stopCnt'+stopsPrefix]||0;
 for(var wi=1;wi<=nStops;wi++){
 var wv=document.getElementById('stop-'+stopsPrefix+'-'+wi);
 if(wv&&wv.value.trim())waypoints.push({location:wv.value.trim(),stopover:true});
 }
 var ds=new google.maps.DirectionsService();
 ds.route({origin:origin,destination:destination,waypoints:waypoints,optimizeWaypoints:false,travelMode:google.maps.TravelMode.DRIVING},function(result,status){
 if(status==='OK'){
 var route=result.routes[0];
 var legs=route.legs;
 var totalDist=0,totalDur=0;
 legs.forEach(function(l){totalDist+=l.distance.value;totalDur+=l.duration.value;});
 var distKm=Math.ceil(totalDist/1000)+' km';
 var durMins=Math.round(totalDur/60);
 var durH=Math.floor(durMins/60),durM=durMins%60;
 var durText=(durH?durH+' h ':'')+durM+' min';
 var enc=route.overview_polyline;
 var pts=[],i=0,lat=0,lng=0;
 while(i<enc.length){
 var b,s=0,r=0;
 do{b=enc.charCodeAt(i++)-63;r|=(b&0x1f)<<s;s+=5;}while(b>=0x20);
 lat+=(r&1)?~(r>>1):(r>>1);s=0;r=0;
 do{b=enc.charCodeAt(i++)-63;r|=(b&0x1f)<<s;s+=5;}while(b>=0x20);
 lng+=(r&1)?~(r>>1):(r>>1);
 pts.push({lat:lat/1e5,lng:lng/1e5});
 }
 new google.maps.Polyline({path:pts,geodesic:true,strokeColor:'#B8A06A',strokeOpacity:0.9,strokeWeight:5,map:map});
 bounds=new google.maps.LatLngBounds();
 pts.forEach(function(p){bounds.extend(p);});
 var letters='ABCDEFGHIJ';
 addMarker(map,legs[0].start_location,letters[0],true);
 legs.forEach(function(l,i){addMarker(map,l.end_location,letters[i+1],i===legs.length-1?false:true);});
 map.fitBounds(bounds,{top:40,right:60,bottom:60,left:60});
 if(durationBadge)durationBadge.innerHTML=distKm+'&nbsp;<span style="opacity:.5">|</span>&nbsp;'+durText;
 if(durationBadge)durationBadge.style.display='block';
 var etaEl=document.getElementById('recap-eta-val');
 if(etaEl&&totalDur){
 var depTime=ST.sub==='one-way'?val('ow-time'):val('bth-time');
 if(depTime&&depTime.indexOf(':')>-1){
 var parts=depTime.split(':');
 var depMins=parseInt(parts[0])*60+parseInt(parts[1]);
 var arrMins=depMins+Math.round(totalDur/60);
 var arrH=Math.floor(arrMins/60)%24,arrM=arrMins%60;
 var arrStr=(arrH<10?'0':'')+arrH+':'+(arrM<10?'0':'')+arrM;
 etaEl.textContent='est. '+arrStr;
 var etaWrap=document.getElementById('recap-eta');
 if(etaWrap)etaWrap.style.display='flex';
 }
 }
 
 }
 });
 }
 });
 });
 }
 if(typeof google!=='undefined'&&google.maps&&google.maps.Map){
 setTimeout(function(){
 initMap();
 setTimeout(function(){
 var mapEl=gi('mb-route-map');
 if(mapEl){
 mapEl.style.borderRadius='0';
 var allChildren=mapEl.querySelectorAll('*');
 allChildren.forEach(function(el){el.style.borderRadius='0';});
 }
 },1500);
 },80);
 } else {
 var t=0,p=setInterval(function(){
 if(++t>60){clearInterval(p);return;}
 if(typeof google!=='undefined'&&google.maps&&google.maps.Map){clearInterval(p);setTimeout(initMap,80);}
 },200);
 }
}
var _bbtn1=gi('btn1');if(_bbtn1)_bbtn1.addEventListener('click',function(){
 if(ST.svcs.length===0){showErr('Please select at least one service.');return;}
 buildTabs();initHeliDDs();try{if(ST.tab==='table')tbInit();}catch(e){console.warn('tbInit:',e);}
 initTimeDD('trig-h-t1','list-h-t1','heliT1','disp-h-t1');
 initTimeDD('trig-h-t2','list-h-t2','heliT2','disp-h-t2');
 initTimeDD('trig-ow-time','list-ow-time','owTime','disp-ow-time');
 initDatePicker('trig-ow-date','list-ow-date','ow-date','disp-ow-date');
 initDatePicker('trig-ow-ret-date','list-ow-ret-date','ow-ret-date','disp-ow-ret-date');
 initDatePicker('trig-bth-date','list-bth-date','bth-date','disp-bth-date');
 initDatePicker('trig-h-date1','list-h-date1','h-date1','disp-h-date1');
 initDatePicker('trig-h-date2','list-h-date2','h-date2','disp-h-date2');
 initDatePicker('trig-cr-start','list-cr-start','cr-start','disp-cr-start');
 initDatePicker('trig-cr-end','list-cr-end','cr-end','disp-cr-end');
 if(gi('trig-tb-date-1'))initDatePicker('trig-tb-date-1','list-tb-date-1','tb-date-1','disp-tb-date-1',function(){if(typeof tbUpdateSummary==='function')tbUpdateSummary(1);});
 initTimeDD('trig-ow-ret-time','list-ow-ret-time','owRetTime','disp-ow-ret-time');
 initTimeDD('trig-bth-time','list-bth-time','bthTime','disp-bth-time');
 if(gi('trig-tb-time-1'))initTimeDD('trig-tb-time-1','list-tb-time-1','tbTime1','disp-tb-time-1',[11,12,13,14,15,16,17,18,19,20,21,22,23,0,1,2]);
 initBthDurDD();
 setTimeout(initAutocomplete,200);
 goTo('2');
});
var _bbtn2_prev=gi('btn2-prev');if(_bbtn2_prev)_bbtn2_prev.addEventListener('click',function(){goTo('1');});
var _bbtn2_next=gi('btn2-next');if(_bbtn2_next)_bbtn2_next.addEventListener('click',function(){
 if(!validateStep2())return;
 try{
 if(ST.svcs.indexOf('helicopter')>-1){buildHeliCards();updateHeliPrices();goTo('2b');}
 else if(ST.svcs.indexOf('chauffeur')>-1){buildVehCards();goTo('2c');}
 else goTo('3');
 }catch(e){console.error('btn2-next error:',e);showErr('Navigation error: '+e.message);}
});
var _bbtn2b_prev=gi('btn2b-prev');if(_bbtn2b_prev)_bbtn2b_prev.addEventListener('click',function(){goTo('2');});
var _bbtn2b_next=gi('btn2b-next');if(_bbtn2b_next)_bbtn2b_next.addEventListener('click',function(){
 if(!ST.selHeli){showErr('Please select a helicopter.');return;}
 if(ST.svcs.indexOf('chauffeur')>-1){buildVehCards();goTo('2c');}
 else goTo('3');
});
var _bbtn2c_prev=gi('btn2c-prev');if(_bbtn2c_prev)_bbtn2c_prev.addEventListener('click',function(){
 if(ST.svcs.indexOf('helicopter')>-1)goTo('2b'); else goTo('2');
});
var _bbtn2c_next=gi('btn2c-next');if(_bbtn2c_next)_bbtn2c_next.addEventListener('click',function(){
 if(!ST.selVeh){showErr('Please select a vehicle.');return;}
 goTo('3');
});
var _bbtn3_prev=gi('btn3-prev');if(_bbtn3_prev)_bbtn3_prev.addEventListener('click',function(){
 if(ST.svcs.indexOf('chauffeur')>-1)goTo('2c');
 else if(ST.svcs.indexOf('helicopter')>-1)goTo('2b');
 else goTo('2');
});
var _bbtn3_next=gi('btn3-next');if(_bbtn3_next)_bbtn3_next.addEventListener('click',function(){if(!validateStep3())return;buildRecap();goTo('4');});
var _bbtn4_prev=gi('btn4-prev');if(_bbtn4_prev)_bbtn4_prev.addEventListener('click',function(){goTo('3');});
var EJS_SERVICE = 'service_36l0tek';
var EJS_ADMIN = 'Template_admin';
var EJS_CLIENT = 'Template_client';
var EJS_PUBKEY = 'fFU32BL7jSL325cWK';
emailjs.init({publicKey: EJS_PUBKEY});
function buildSummaryText(){
 var lines=[];
 ST.svcs.forEach(function(svc){
 if(svc==='chauffeur'){
 if(ST.sub==='one-way'){
 lines.push('--- Chauffeur — One Way Transfer ---');
 lines.push('From: '+val('ow-from'));
 lines.push('To: '+val('ow-to'));
 lines.push('Date: '+fmtDate(val('ow-date')));
 lines.push('Time: '+(ST.owTime||''));
 var _ad=parseInt((gi('ow-adults-v')||{textContent:'1'}).textContent)||1;
 var _ch=parseInt((gi('ow-children-v')||{textContent:'0'}).textContent)||0;
 var _ba=parseInt((gi('ow-babies-v')||{textContent:'0'}).textContent)||0;
 var _pe=parseInt((gi('ow-pets-v')||{textContent:'0'}).textContent)||0;
 var _pp=[];
 if(_ad)_pp.push(_ad+' adult'+(_ad>1?'s':''));
 if(_ch)_pp.push(_ch+' child'+(_ch>1?'ren':''));
 if(_ba)_pp.push(_ba+' baby'+(_ba>1?'ies':''));
 if(_pe)_pp.push(_pe+' pet'+(_pe>1?'s':''));
 lines.push('Passengers: '+(_pp.join(', ')||'1 adult'));
 var _cab=parseInt((gi('ow-cabin-v')||{textContent:'0'}).textContent)||0;
 var _hold=parseInt((gi('ow-hold-v')||{textContent:'0'}).textContent)||0;
 var _spec=parseInt((gi('ow-special-v')||{textContent:'0'}).textContent)||0;
 var _lp=[];
 if(_cab)_lp.push(_cab+' cabin');
 if(_hold)_lp.push(_hold+' hold');
 if(_spec)_lp.push(_spec+' special');
 if(_lp.length)lines.push('Luggage: '+_lp.join(', '));
 var _veh=VEHICLES.find(function(x){return x.id===ST.selVeh;});
 if(_veh)lines.push('Vehicle: '+_veh.name);
 } else {
 lines.push('--- Chauffeur — By the Hour ---');
 lines.push('Pickup: '+val('bth-pickup'));
 lines.push('Date: '+fmtDate(val('bth-date')));
 lines.push('Duration: '+val('bth-hours')+'h');
 lines.push('Time: '+(ST.bthTime||''));
 var _ad2=parseInt((gi('bth-adults-v')||{textContent:'1'}).textContent)||1;
 var _ch2=parseInt((gi('bth-children-v')||{textContent:'0'}).textContent)||0;
 var _ba2=parseInt((gi('bth-babies-v')||{textContent:'0'}).textContent)||0;
 var _pe2=parseInt((gi('bth-pets-v')||{textContent:'0'}).textContent)||0;
 var _pp2=[];
 if(_ad2)_pp2.push(_ad2+' adult'+(_ad2>1?'s':''));
 if(_ch2)_pp2.push(_ch2+' child'+(_ch2>1?'ren':''));
 if(_ba2)_pp2.push(_ba2+' baby'+(_ba2>1?'ies':''));
 if(_pe2)_pp2.push(_pe2+' pet'+(_pe2>1?'s':''));
 lines.push('Passengers: '+(_pp2.join(', ')||'1 adult'));
 var _cab2=parseInt((gi('bth-cabin-v')||{textContent:'0'}).textContent)||0;
 var _hold2=parseInt((gi('bth-hold-v')||{textContent:'0'}).textContent)||0;
 var _spec2=parseInt((gi('bth-special-v')||{textContent:'0'}).textContent)||0;
 var _lp2=[];
 if(_cab2)_lp2.push(_cab2+' cabin');
 if(_hold2)_lp2.push(_hold2+' hold');
 if(_spec2)_lp2.push(_spec2+' special');
 if(_lp2.length)lines.push('Luggage: '+_lp2.join(', '));
 var _veh2=VEHICLES.find(function(x){return x.id===ST.selVeh;});
 if(_veh2)lines.push('Vehicle: '+_veh2.name);
 }
 }
 if(svc==='helicopter'){
 lines.push('--- Helicopter Transfer ---');
 lines.push('From: '+(ST.heliDep||''));
 lines.push('To: '+(ST.heliDest||''));
 lines.push('Date: '+fmtDate(val('h-date1')));
 lines.push('Time: '+(ST.heliT1||''));
 var _had=parseInt((gi('h-adults-v')||{textContent:'1'}).textContent)||1;
 var _hch=parseInt((gi('h-children-v')||{textContent:'0'}).textContent)||0;
 var _hba=parseInt((gi('h-babies-v')||{textContent:'0'}).textContent)||0;
 var _hpp=[];
 if(_had)_hpp.push(_had+' adult'+(_had>1?'s':''));
 if(_hch)_hpp.push(_hch+' child'+(_hch>1?'ren':''));
 if(_hba)_hpp.push(_hba+' baby'+(_hba>1?'ies':''));
 lines.push('Passengers: '+(_hpp.join(', ')||'1 adult'));
 var _hcab=parseInt((gi('h-cabin-v')||{textContent:'0'}).textContent)||0;
 var _hhold=parseInt((gi('h-hold-v')||{textContent:'0'}).textContent)||0;
 var _hspec=parseInt((gi('h-special-v')||{textContent:'0'}).textContent)||0;
 var _hlp=[];
 if(_hcab)_hlp.push(_hcab+' cabin');
 if(_hhold)_hlp.push(_hhold+' suitcase'+(_hhold>1?'s':''));
 if(_hspec)_hlp.push(_hspec+' special');
 if(_hlp.length)lines.push('Luggage: '+_hlp.join(', '));
 if(ST.selHeli){var hh=HELICOPTERS.find(function(x){return x.id===ST.selHeli;});if(hh)lines.push('Aircraft: '+hh.name);}
 }
 if(svc==='car-rental'){
 lines.push('--- Luxury Car Rental ---');
 lines.push('Type: '+val('cr-type'));
 lines.push('Brand: '+val('cr-brand'));
 lines.push('From: '+fmtDate(val('cr-start')));
 lines.push('Until: '+fmtDate(val('cr-end')));
 lines.push('Pickup: '+val('cr-pickup'));
 if(val('cr-age'))lines.push('Driver age: '+val('cr-age'));
 if(val('cr-licence'))lines.push('Licence: '+val('cr-licence'));
 }
 if(svc==='table'){
 lines.push('--- Table Reservation ---');
 var cards=document.querySelectorAll('.tb-resto-card');
 for(var ri=0;ri<Math.max(cards.length,1);ri++){
 var n=ri+1;
 lines.push('Restaurant '+n+': '+(val('tb-city-'+n)||'—')+' · '+fmtDate(val('tb-date-'+n))+' · '+((document.getElementById('tb-time-'+n)||{}).value||'—')+' · '+(val('tb-covers-'+n)||'—')+' guests');
 if(val('tb-occ-'+n)&&val('tb-occ-'+n)!=='None')lines.push(' Occasion: '+val('tb-occ-'+n));
 if(val('tb-resto-'+n))lines.push(' Restaurant: '+val('tb-resto-'+n));
 }
 }
 });
 var isOtherSum=gi('other-toggle')&&gi('other-toggle').checked;
 if(isOtherSum&&(val('pax-first')||val('pax-last'))){
 lines.push('');
 lines.push('--- Lead Passenger ---');
 lines.push('Name: '+val('pax-first')+' '+val('pax-last'));
 if(val('pax-phone'))lines.push('Phone: '+paxPhoneState.code+' '+val('pax-phone'));
 }
 var isBillSum=gi('bill-toggle')&&gi('bill-toggle').checked;
 if(isBillSum&&(val('bill-company')||val('bill-addr'))){
 lines.push('');
 lines.push('--- Billing Information ---');
 if(val('bill-company'))lines.push('Company: '+val('bill-company'));
 if(val('bill-vat'))lines.push('VAT: '+val('bill-vat'));
 var bAddr=[val('bill-addr'),val('bill-zip'),val('bill-city'),val('bill-country')].filter(Boolean).join(', ');
 if(bAddr)lines.push('Address: '+bAddr);
 if(val('bill-email'))lines.push('Billing email: '+val('bill-email'));
 }
 return lines.join('\n');
}

var _bmb_submit=gi('mb-submit');if(_bmb_submit)_bmb_submit.addEventListener('click',function(){
 if(!validateStep3())return;
 var btn=gi('mb-submit');
 btn.disabled=true;
 btn.textContent='Sending…';
 var now=new Date();
 var dateStr=now.toLocaleDateString('en-GB',{day:'2-digit',month:'long',year:'numeric'})+' · '+now.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit'})+' CET';
 var summaryText=buildSummaryText();
 var serviceLabel=ST.svcs.map(function(s){return({chauffeur:'Chauffeur Service',helicopter:'Helicopter Transfer','car-rental':'Luxury Car Rental',table:'Table Reservation'})[s]||s;}).join(' + ');
 var clientName=(val('ct-first')||'')+' '+(val('ct-last')||'');
 var clientPhone=(ST.phone&&ST.phone.code?ST.phone.code+' ':'')+val('ct-phone');
 var clientPhoneRaw=(ST.phone&&ST.phone.code?ST.phone.code.replace(/[^0-9]/g,''):'33')+val('ct-phone').replace(/[^0-9]/g,'');
 var summaryClient=summaryText;
 var billMarker='\n--- Billing Information ---';
 var billIdx=summaryClient.indexOf(billMarker);
 if(billIdx>-1)summaryClient=summaryClient.substring(0,billIdx);
 var paramsAdmin={
 service_type: serviceLabel,
 client_name: clientName.trim(),
 client_email: val('ct-email'),
 client_phone: clientPhone,
 client_phone_raw:clientPhoneRaw,
 booking_summary: summaryText,
 submission_date: dateStr
 };
 var paramsClient={
 service_type: serviceLabel,
 client_name: clientName.trim(),
 client_email: val('ct-email'),
 client_phone: clientPhone,
 client_phone_raw:clientPhoneRaw,
 booking_summary: summaryClient,
 submission_date: dateStr
 };
 Promise.all([
   emailjs.send(EJS_SERVICE, EJS_ADMIN, paramsAdmin),
   emailjs.send(EJS_SERVICE, EJS_CLIENT, paramsClient)
   ]).then(function(){
   document.querySelectorAll('.mb-step').forEach(function(s){s.classList.remove('is-active');s.style.display='none';});
   gi('mb-success').classList.add('is-on');
   document.querySelector('.mb-shell').scrollIntoView({behavior:'smooth',block:'start'});
   }).catch(function(err){
 console.error('EmailJS error:', err);
 btn.disabled=false;
 btn.textContent='Submit booking request';
 alert('Failed to send. Please contact us directly at info@leaderlimousines.com');
 });
});
buildPhoneList();
initStops('btn-add-stop-ow','stops-ow','OW');
initStops('btn-add-stop-bth','stops-bth','BTH');
initReturnToggle('btn-add-ret-ow','ow-ret-wrap','hasRetOW');
initReturnToggle('btn-add-ret-h','h-ret-wrap','hasRetH');
initPaxPanel('trig-ow-pax','panel-ow-pax');
initPaxPanel('trig-ow-bag','panel-ow-bag');
initPaxPanel('trig-bth-pax','panel-bth-pax');
initPaxPanel('trig-bth-bag','panel-bth-bag');
initPaxPanel('trig-h-pax','panel-h-pax');
initPaxPanel('trig-h-bag','panel-h-bag');
initLocField('ow-from','dd-ow-from','btn-ap-ow-from','btn-tr-ow-from','ow-from',true);
initLocField('ow-to','dd-ow-to','btn-ap-ow-to','btn-tr-ow-to',null,false);
initLocField('bth-pickup','dd-bth-pickup','btn-ap-bth','btn-tr-bth','bth',true);
setProgress('1');
loadHeliPrices();
var TB_COUNT = 1; 
var TB_OPEN = null;
function tbMakeSummary(n) {
 var city = val('tb-city-'+n) || '';
 var date = val('tb-date-'+n) || '';
 var time = document.getElementById('tb-time-'+n) ? document.getElementById('tb-time-'+n).value : '';
 var guests = val('tb-covers-'+n) || '';
 var parts = [];
 if(city) parts.push(city);
 if(date) parts.push(fmtDate(date));
 if(time) parts.push(time);
 if(guests) parts.push(guests+' guests');
 return parts.join(' · ') || 'Fill in details';
}
function tbUpdateSummary(n) {
 var s = document.getElementById('tb-summary-'+n);
 if(s) s.textContent = tbMakeSummary(n);
}
function tbToggle(n) {
 var card = document.getElementById('tb-card-'+n);
 if(!card) return;
 var isOpen = card.classList.contains('is-open');
 document.querySelectorAll('.tb-resto-card').forEach(function(c){ c.classList.remove('is-open'); });
 if(!isOpen) {
 card.classList.add('is-open');
 TB_OPEN = n;
 } else {
 TB_OPEN = null;
 }
}
function tbDeleteResto(n) {
 var card = document.getElementById('tb-card-'+n);
 if(card) card.remove();
 tbRenumber();
}
function tbRenumber() {
 var dynamicCards = document.querySelectorAll('#tb-resto-list .tb-resto-card');
 dynamicCards.forEach(function(card, i) {
 var num = card.querySelector('.tb-resto-num');
 if(num) num.textContent = i+2;
 var title = card.querySelector('.tb-resto-title span');
 if(title) title.textContent = 'Restaurant '+(i+2);
 var del = card.querySelector('.tb-resto-del');
 if(del) del.style.display = 'flex';
 });
}
function tbAddResto() {
 TB_COUNT++;
 var n = TB_COUNT;
 var card = document.createElement('div');
 card.className = 'tb-resto-card';
 card.id = 'tb-card-'+n;
 card.innerHTML =
 '<div class="tb-resto-hdr" onclick="tbToggle('+n+')">' +
 '<div class="tb-resto-num">'+n+'</div>' +
 '<div style="flex:1">' +
 '<div class="tb-resto-title"><span>Restaurant '+n+'</span></div>' +
 '<div class="tb-resto-summary" id="tb-summary-'+n+'">Fill in details</div>' +
 '</div>' +
 '<button type="button" class="tb-resto-del" onclick="event.stopPropagation();tbDeleteResto('+n+')" title="Remove"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
 '<svg class="tb-resto-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>' +
 '</div>' +
 '<div class="tb-resto-body">' +
 '<div class="mb-grid">' +
 '<div class="mb-f"><label class="mb-flbl">City *</label><select id="tb-city-'+n+'" onchange="tbUpdateSummary('+n+')"><option value="">Select city</option><option>Cannes</option><option>Monaco</option><option>Nice</option><option>Saint-Tropez</option><option>Antibes</option><option>Courchevel</option><option>Megève</option><option>Paris</option><option>Milan</option><option>Other</option></select></div>' +
 '<div class="mb-f"><label class="mb-flbl">Restaurant name</label><input type="text" id="tb-resto-'+n+'" placeholder="Leave blank if no preference"></div>' +
 '<div class="mb-f"><label class="mb-flbl">Date *</label><input type="date" id="tb-date-'+n+'" onchange="tbUpdateSummary('+n+')"></div>' +
 '<div class="mb-f"><label class="mb-flbl">Time *</label><div class="mb-dd-wrap"><div class="mb-dd-trigger" id="trig-tb-time-'+n+'"><div class="mb-dd-val ph" id="disp-tb-time-'+n+'">Select time</div><svg class="mb-dd-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></div><div class="mb-dd-list" id="list-tb-time-'+n+'"></div></div><input type="hidden" id="tb-time-'+n+'" onchange="tbUpdateSummary('+n+')"></div>' +
 '<div class="mb-f"><label class="mb-flbl">Guests *</label><select id="tb-covers-'+n+'" onchange="tbUpdateSummary('+n+')"><option value="">Number</option>'+'<option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option><option>8</option><option>9</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option>'+'</select></div>' +
 '<div class="mb-f"><label class="mb-flbl">Special occasion</label><select id="tb-occ-'+n+'"><option>None</option><option>Birthday</option><option>Anniversary</option><option>Proposal</option><option>Business dinner</option><option>Celebration</option><option>Other</option></select></div>' +
 '</div>' +
 '</div>';
 document.getElementById('tb-resto-list').appendChild(card);
 initTimeDD('trig-tb-time-'+n, 'list-tb-time-'+n, 'tbTime'+n, 'disp-tb-time-'+n,[11,12,13,14,15,16,17,18,19,20,21,22,23,0,1,2]);
 document.querySelectorAll('.tb-resto-card').forEach(function(c){ c.classList.remove('is-open'); });
 card.classList.add('is-open');
 TB_OPEN = n;
 tbUpdateSummary(1);
 tbRenumber();
}
function tbInit() {
 var trig = document.getElementById('trig-tb-time-1');
 if(trig && !trig._tbInited) {
 trig._tbInited = true;
 initTimeDD('trig-tb-time-1','list-tb-time-1','tbTime1','disp-tb-time-1',[11,12,13,14,15,16,17,18,19,20,21,22,23,0,1,2]);
 }
}
 function dchip(k,v){if(!v||v==='—')return '';return '<div class="mb-recap-chip"><div class="mb-recap-chip-body"><div class="mb-recap-chip-lbl">'+k+'</div><div class="mb-recap-chip-val">'+v+'</div></div></div>';}
window.tbAddResto = tbAddResto;
window.tbToggle = tbToggle;
window.tbDeleteResto = tbDeleteResto;
window.tbUpdateSummary = tbUpdateSummary;     

var _crmBtn=gi('mb-submit');                                                                                                                                                                              
  if(_crmBtn){_crmBtn.addEventListener('click',function(){                                                                                                                                                  
    setTimeout(function(){
      try{                                                                                                                                                                                                  
        var _owStops=[];                                    
        for(var _i=1;_i<=(ST.stopCntOW||0);_i++){var _v=val('stop-OW-'+_i);if(_v)_owStops.push(_v);}                                                                                                        
        var _bthStops=[];                                                                                                                                                                                   
        for(var _j=1;_j<=(ST.stopCntBTH||0);_j++){var _w=val('stop-BTH-'+_j);if(_w)_bthStops.push(_w);}
        var _table=[];                                                                                                                                                                                      
        var _cards=document.querySelectorAll('.tb-resto-card');
        for(var _k=1;_k<=Math.max(_cards.length,1);_k++){                                                                                                                                                   
          _table.push({                                     
            n:_k,                                                                                                                                                                                           
            city:val('tb-city-'+_k),                        
            resto:val('tb-resto-'+_k),                                                                                                                                                                      
            date:val('tb-date-'+_k),
            time:(gi('tb-time-'+_k)||{}).value||'',                                                                                                                                                         
            covers:val('tb-covers-'+_k),                                                                                                                                                                    
            occ:val('tb-occ-'+_k)
          });                                                                                                                                                                                               
        }                                                   
        function _n(id){return parseInt((gi(id)||{textContent:'0'}).textContent)||0;}
        var p={                                                                                                                                                                                             
          secret:'LL-CRM-7k3q2xZp9mW8R4hNtYbVcDf',
          services:ST.svcs,                                                                                                                                                                                 
          sub:ST.sub||null,                                                                                                                                                                                 
          sel_heli:ST.selHeli||null,                                                                                                                                                                        
          sel_veh:ST.selVeh||null,                                                                                                                                                                          
          heliDep:ST.heliDep||null,                         
          heliDest:ST.heliDest||null,                                                                                                                                                                       
          heliT1:ST.heliT1||null,                           
          heliT2:ST.heliT2||null,                                                                                                                                                                           
          ow:{                                                                                                                                                                                              
            from:val('ow-from'),
            to:val('ow-to'),                                                                                                                                                                                
            date:val('ow-date'),                            
            time:ST.owTime||val('ow-time'),                                                                                                                                                                 
            flight:val('ow-from-flight'),
            sign:val('ow-from-sign'),                                                                                                                                                                       
            train:val('ow-from-train')||val('ow-to-train'), 
            retDate:val('ow-ret-date'),                                                                                                                                                                     
            retTime:ST.owRetTime||val('ow-ret-time'),
            adults:_n('ow-adults-v'),                                                                                                                                                                       
            children:_n('ow-children-v'),                   
            babies:_n('ow-babies-v'),                                                                                                                                                                       
            pets:_n('ow-pets-v'),                                                                                                                                                                           
            cabin:_n('ow-cabin-v'),
            hold:_n('ow-hold-v'),                                                                                                                                                                           
            special:_n('ow-special-v'),  
            infant:_n('ow-infant-v'),                                                                                                                                                                       
            childS:_n('ow-child-s-v'),                                                                                                                                                                      
            booster:_n('ow-booster-v'),                   
            notes:val('ow-notes'),                                                                                                                                                                          
            hasReturn:!!ST.hasRetOW,
            stops:_owStops                                                                                                                                                                                  
          },                                                                                                                                                                                                
          bth:{
            pickup:val('bth-pickup'),                                                                                                                                                                       
            date:val('bth-date'),                           
            time:ST.bthTime||val('bth-time'),
            hours:val('bth-hours'),
            flight:val('bth-flight'),                                                                                                                                                                       
            sign:val('bth-sign'),
            train:val('bth-train'),                                                                                                                                                                         
            adults:_n('bth-adults-v'),                      
            children:_n('bth-children-v'),                                                                                                                                                                  
            babies:_n('bth-babies-v'),
            pets:_n('bth-pets-v'),                                                                                                                                                                          
            cabin:_n('bth-cabin-v'),                        
            hold:_n('bth-hold-v'),                                                                                                                                                                          
            special:_n('bth-special-v'),
            infant:_n('bth-infant-v'),                                                                                                                                                                      
            childS:_n('bth-child-s-v'),
            booster:_n('bth-booster-v'),
            notes:val('bth-notes'),                                                                                                                                                                         
            stops:_bthStops                                 
          },
          heli:{
            date1:val('h-date1'),                                                                                                                                                                           
            date2:val('h-date2'),
            hasReturn:!!ST.hasRetH,                                                                                                                                                                         
            adults:_n('h-adults-v'),                        
            children:_n('h-children-v'),                                                                                                                                                                    
            babies:_n('h-babies-v'),
            cabin:_n('h-cabin-v'),                                                                                                                                                                          
            hold:_n('h-hold-v'),                                                                                                                                                                            
            special:_n('h-special-v')
          },                                                                                                                                                                                                
          cr:{                                              
            type:val('cr-type'),
            brand:val('cr-brand'),
            start:val('cr-start'),                                                                                                                                                                          
            end:val('cr-end'),
            pickup:val('cr-pickup'),                                                                                                                                                                        
            age:val('cr-age'),                              
            licence:val('cr-licence'),
            notes:val('cr-notes')                                                                                                                                                                           
          },
          table:_table,                                                                                                                                                                                     
          tableNotes:val('tb-notes'),                       
          contact:{
            isOther:!!(gi('other-toggle')&&gi('other-toggle').checked),
            paxFirst:val('pax-first'),                                                                                                                                                                      
            paxLast:val('pax-last'),
            paxPhone:val('pax-phone'),                                                                                                                                                                      
            paxCode:(paxPhoneState&&paxPhoneState.code)||'',                                                                                                                                                
            firstName:val('ct-first'),
            lastName:val('ct-last'),                                                                                                                                                                        
            email:val('ct-email'),                                                                                                                                                                          
            phone:val('ct-phone'),
            phoneCode:(ST.phone&&ST.phone.code)||''                                                                                                                                                         
          },                                                
          billing:{
            enabled:!!(gi('bill-toggle')&&gi('bill-toggle').checked),
            company:val('bill-company'),                                                                                                                                                                    
            vat:val('bill-vat'),
            addr:val('bill-addr'),                                                                                                                                                                          
            city:val('bill-city'),                                                                                                                                                                          
            zip:val('bill-zip'),
            country:val('bill-country'),                                                                                                                                                                    
            email:val('bill-email')                         
          }                                                                                                                                                                                                 
        };
        fetch('https://leader-crm.divine-union-7c00.workers.dev/api/booking',{                                                                                                                              
          method:'POST',                                    
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify(p)                                                                                                                                                                            
        }).catch(function(){});
      }catch(e){}                                                                                                                                                                                           
    },100);                                                 
  });}


};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',_run);}else{_run();}})();
